/**
* This file was @generated using pocketbase-typegen
*/

import type PocketBase from 'pocketbase'
import type { RecordService } from 'pocketbase'

export enum Collections {
	Authorigins = "_authOrigins",
	Externalauths = "_externalAuths",
	Mfas = "_mfas",
	Otps = "_otps",
	Superusers = "_superusers",
	AdminImpersonationSessions = "admin_impersonation_sessions",
	BusinessCommunityRateLimits = "business_community_rate_limits",
	BusinessCommunitySafety = "business_community_safety",
	BusinessConversations = "business_conversations",
	BusinessEmbedConfigs = "business_embed_configs",
	BusinessEmbedRateLimits = "business_embed_rate_limits",
	BusinessEmbedReferralDaily = "business_embed_referral_daily",
	BusinessEntitlements = "business_entitlements",
	BusinessFeatureFlags = "business_feature_flags",
	BusinessFinanceAccess = "business_finance_access",
	BusinessFinanceAudit = "business_finance_audit",
	BusinessFinanceLedger = "business_finance_ledger",
	BusinessFollows = "business_follows",
	BusinessMessages = "business_messages",
	BusinessPilotAudit = "business_pilot_audit",
	BusinessPilotPrograms = "business_pilot_programs",
	BusinessPilotRoster = "business_pilot_roster",
	BusinessPlans = "business_plans",
	BusinessPostComments = "business_post_comments",
	BusinessPosts = "business_posts",
	BusinessReconciliationExceptions = "business_reconciliation_exceptions",
	BusinessResources = "business_resources",
	BusinessSettlements = "business_settlements",
	BusinessSubscriptionEvents = "business_subscription_events",
	BusinessSubscriptionInvoices = "business_subscription_invoices",
	BusinessSubscriptions = "business_subscriptions",
	BusinessSupportCases = "business_support_cases",
	ClientDiagnosticRateBuckets = "client_diagnostic_rate_buckets",
	ClientDiagnostics = "client_diagnostics",
	ContactDiscoveryRequests = "contact_discovery_requests",
	Countries = "countries",
	CustomerReceipts = "customer_receipts",
	EphemeralRsvps = "ephemeral_rsvps",
	EventAgeProfiles = "event_age_profiles",
	EventAnticipationOptions = "event_anticipation_options",
	EventAnticipationPrompts = "event_anticipation_prompts",
	EventAnticipationResponses = "event_anticipation_responses",
	EventAnticipationState = "event_anticipation_state",
	EventBookmarks = "event_bookmarks",
	EventChats = "event_chats",
	EventChatsView = "event_chats_view",
	EventCheckInAudit = "event_check_in_audit",
	EventCompanyBlocks = "event_company_blocks",
	EventCompanyMatches = "event_company_matches",
	EventCompanyMessages = "event_company_messages",
	EventCompanyOptIns = "event_company_opt_ins",
	EventCompanyRateLimits = "event_company_rate_limits",
	EventCompanyReactions = "event_company_reactions",
	EventCompanyReports = "event_company_reports",
	EventCompanyRoomMembers = "event_company_room_members",
	EventCompanyRoomSignals = "event_company_room_signals",
	EventCompanyRooms = "event_company_rooms",
	EventContentReports = "event_content_reports",
	EventFeedback = "event_feedback",
	EventImpressions = "event_impressions",
	EventMembers = "event_members",
	EventMemories = "event_memories",
	EventNotificationDeliveries = "event_notification_deliveries",
	EventOrganizerAudit = "event_organizer_audit",
	EventOrganizers = "event_organizers",
	EventPlanOptions = "event_plan_options",
	EventPlanParticipants = "event_plan_participants",
	EventPlanVotes = "event_plan_votes",
	EventPlans = "event_plans",
	EventPostComments = "event_post_comments",
	EventPostCommentsView = "event_post_comments_view",
	EventPosts = "event_posts",
	EventPostsView = "event_posts_view",
	EventRefundRequests = "event_refund_requests",
	EventSeries = "event_series",
	EventTicketChallenges = "event_ticket_challenges",
	EventTicketTransfers = "event_ticket_transfers",
	EventTickets = "event_tickets",
	EventView = "event_view",
	Events = "events",
	EventsView = "events_view",
	FeatureFlags = "feature_flags",
	GroupCategories = "group_categories",
	GroupInviteLinks = "group_invite_links",
	GroupMembers = "group_members",
	GroupMembersView = "group_members_view",
	GroupPostComments = "group_post_comments",
	GroupPostCommentsView = "group_post_comments_view",
	GroupPosts = "group_posts",
	GroupPostsView = "group_posts_view",
	GroupView = "group_view",
	Groups = "groups",
	GroupsView = "groups_view",
	HostEventAnalytics = "host_event_analytics",
	HostReliabilitySignals = "host_reliability_signals",
	LaunchEvents = "launch_events",
	ModerationActions = "moderation_actions",
	ModerationAppeals = "moderation_appeals",
	ModerationReports = "moderation_reports",
	NotificationDigestDeliveries = "notification_digest_deliveries",
	Notifications = "notifications",
	NotificationsView = "notifications_view",
	PeopleCircleMembers = "people_circle_members",
	PeopleCircles = "people_circles",
	PeopleListMembers = "people_list_members",
	PeopleLists = "people_lists",
	PhoneVerificationAttempts = "phone_verification_attempts",
	PlanMatchRateLimits = "plan_match_rate_limits",
	PlatformAdminActions = "platform_admin_actions",
	PlatformSettings = "platform_settings",
	PostEventContinuityState = "post_event_continuity_state",
	PrivacyActionAudit = "privacy_action_audit",
	ProfileBlocks = "profile_blocks",
	PushSubscriptions = "push_subscriptions",
	RecentPeople = "recent_people",
	ResourceAvailabilityRules = "resource_availability_rules",
	ResourceBlackouts = "resource_blackouts",
	ResourceBookingAudit = "resource_booking_audit",
	ResourceBookings = "resource_bookings",
	ResourceMaintenance = "resource_maintenance",
	ResourceOperationNotificationDeliveries = "resource_operation_notification_deliveries",
	ResourceOperationsAudit = "resource_operations_audit",
	ResourceStaffAssignments = "resource_staff_assignments",
	SavedFeeds = "saved_feeds",
	SavedPeople = "saved_people",
	SeedRunResources = "seed_run_resources",
	SeedRuns = "seed_runs",
	Timezones = "timezones",
	TravelReminders = "travel_reminders",
	UserAvailability = "user_availability",
	UserPresence = "user_presence",
	Users = "users",
	UsersView = "users_view",
	VenueApplications = "venue_applications",
	VenueAuditLog = "venue_audit_log",
	VenueEventInsights = "venue_event_insights",
	VenueStaff = "venue_staff",
	VippsFinancialAudit = "vipps_financial_audit",
	VippsPaymentAttempts = "vipps_payment_attempts",
}

// Alias types for improved usability
export type IsoDateString = string
export type IsoAutoDateString = string & { readonly autodate: unique symbol }
export type RecordIdString = string
export type FileNameString = string & { readonly filename: unique symbol }
export type HTMLString = string

export type GeoPoint = {
	lon: number
	lat: number
}

type ExpandType<T> = unknown extends T
	? T extends unknown
		? { expand?: unknown }
		: { expand: T }
	: { expand: T }

// System fields
export type BaseSystemFields<T = unknown> = {
	id: RecordIdString
	collectionId: string
	collectionName: Collections
} & ExpandType<T>

export type AuthSystemFields<T = unknown> = {
	email: string
	emailVisibility: boolean
	username: string
	verified: boolean
} & BaseSystemFields<T>

// Record types for each collection

export type AuthoriginsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	fingerprint: string
	id: string
	recordRef: string
	updated: IsoAutoDateString
}

export type ExternalauthsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	provider: string
	providerId: string
	recordRef: string
	updated: IsoAutoDateString
}

export type MfasRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	method: string
	recordRef: string
	updated: IsoAutoDateString
}

export type OtpsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	password: string
	recordRef: string
	sentTo?: string
	updated: IsoAutoDateString
}

export type SuperusersRecord = {
	created: IsoAutoDateString
	email: string
	emailVisibility?: boolean
	id: string
	password: string
	tokenKey: string
	updated: IsoAutoDateString
	verified?: boolean
}

export enum AdminImpersonationSessionsStatusOptions {
	"active" = "active",
	"ended" = "ended",
	"expired" = "expired",
}
export type AdminImpersonationSessionsRecord = {
	actor_id: RecordIdString
	created: IsoAutoDateString
	ended_at?: IsoDateString
	expires_at: IsoDateString
	id: string
	reason: string
	status: AdminImpersonationSessionsStatusOptions
	target_id: RecordIdString
	updated: IsoAutoDateString
}

export type BusinessCommunityRateLimitsRecord = {
	action: string
	actor_key: string
	count: number
	created: IsoAutoDateString
	id: string
	updated: IsoAutoDateString
	window_start: IsoDateString
}

export enum BusinessCommunitySafetyActionOptions {
	"report" = "report",
	"block" = "block",
}

export enum BusinessCommunitySafetyTargetTypeOptions {
	"business" = "business",
	"post" = "post",
	"comment" = "comment",
	"conversation" = "conversation",
	"message" = "message",
	"user" = "user",
}

export enum BusinessCommunitySafetyStatusOptions {
	"active" = "active",
	"resolved" = "resolved",
	"dismissed" = "dismissed",
}
export type BusinessCommunitySafetyRecord = {
	action: BusinessCommunitySafetyActionOptions
	actor_id: RecordIdString
	created: IsoAutoDateString
	id: string
	reason?: string
	status: BusinessCommunitySafetyStatusOptions
	target_id: string
	target_type: BusinessCommunitySafetyTargetTypeOptions
	updated: IsoAutoDateString
}

export enum BusinessConversationsStatusOptions {
	"open" = "open",
	"closed" = "closed",
	"blocked" = "blocked",
}
export type BusinessConversationsRecord = {
	blocked_by_id?: RecordIdString
	business_id: RecordIdString
	created: IsoAutoDateString
	customer_id: RecordIdString
	id: string
	last_message_at?: IsoDateString
	retention_warned_at?: IsoDateString
	status: BusinessConversationsStatusOptions
	updated: IsoAutoDateString
}

export type BusinessEmbedConfigsRecord<Tallowed_origins = unknown, Tsections = unknown> = {
	accent_color?: string
	allowed_origins: null | Tallowed_origins
	analytics_enabled?: boolean
	business_id: RecordIdString
	created: IsoAutoDateString
	default_locale?: string
	enabled?: boolean
	id: string
	introduction?: string
	sections: null | Tsections
	show_address?: boolean
	show_branding?: boolean
	updated: IsoAutoDateString
}

export enum BusinessEmbedRateLimitsActionOptions {
	"read" = "read",
	"analytics" = "analytics",
}
export type BusinessEmbedRateLimitsRecord = {
	action: BusinessEmbedRateLimitsActionOptions
	business_id: RecordIdString
	count: number
	created: IsoAutoDateString
	id: string
	origin: string
	updated: IsoAutoDateString
	window_start: IsoDateString
}

export enum BusinessEmbedReferralDailySourceOptions {
	"embed" = "embed",
	"public_page" = "public_page",
}

export enum BusinessEmbedReferralDailyEventTypeOptions {
	"impression" = "impression",
	"open_event" = "open_event",
	"open_booking" = "open_booking",
}
export type BusinessEmbedReferralDailyRecord = {
	business_id: RecordIdString
	count: number
	created: IsoAutoDateString
	day: IsoDateString
	event_type: BusinessEmbedReferralDailyEventTypeOptions
	id: string
	source: BusinessEmbedReferralDailySourceOptions
	updated: IsoAutoDateString
}

export enum BusinessEntitlementsKeyOptions {
	"payments" = "payments",
	"parent_events" = "parent_events",
	"enhanced_analytics" = "enhanced_analytics",
	"higher_limits" = "higher_limits",
}
export type BusinessEntitlementsRecord = {
	business_id: RecordIdString
	created: IsoAutoDateString
	enabled?: boolean
	expires_at?: IsoDateString
	id: string
	key: BusinessEntitlementsKeyOptions
	source?: string
	updated: IsoAutoDateString
}

export enum BusinessFeatureFlagsEnvironmentOptions {
	"development" = "development",
	"staging" = "staging",
	"production" = "production",
}

export enum BusinessFeatureFlagsCohortOptions {
	"none" = "none",
	"pilot" = "pilot",
}
export type BusinessFeatureFlagsRecord = {
	cohort: BusinessFeatureFlagsCohortOptions
	created: IsoAutoDateString
	enabled: boolean
	ends_at?: IsoDateString
	environment: BusinessFeatureFlagsEnvironmentOptions
	fallback: string
	id: string
	key: string
	owner_id: RecordIdString
	pilot_id?: RecordIdString
	privileged: boolean
	rationale: string
	starts_at?: IsoDateString
	updated: IsoAutoDateString
	version: number
}

export enum BusinessFinanceAccessRoleOptions {
	"viewer" = "viewer",
	"exporter" = "exporter",
	"administrator" = "administrator",
}
export type BusinessFinanceAccessRecord = {
	business_id: RecordIdString
	created: IsoAutoDateString
	granted_by_id: RecordIdString
	id: string
	revoked_at?: IsoDateString
	role: BusinessFinanceAccessRoleOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export type BusinessFinanceAuditRecord<Tdetails = unknown> = {
	action: string
	actor_id: RecordIdString
	business_id: RecordIdString
	created: IsoAutoDateString
	details?: null | Tdetails
	id: string
	target_id?: string
}

export enum BusinessFinanceLedgerEntryTypeOptions {
	"charge" = "charge",
	"refund" = "refund",
	"fee" = "fee",
	"settlement" = "settlement",
	"correction" = "correction",
}

export enum BusinessFinanceLedgerSourceTypeOptions {
	"event" = "event",
	"resource" = "resource",
	"subscription" = "subscription",
	"provider" = "provider",
}
export type BusinessFinanceLedgerRecord<Tsnapshot = unknown> = {
	amount_minor: number
	business_id: RecordIdString
	created: IsoAutoDateString
	currency: string
	entry_type: BusinessFinanceLedgerEntryTypeOptions
	id: string
	idempotency_key: string
	occurred_at: IsoDateString
	provider_reference?: string
	retain_until: IsoDateString
	settlement_id?: RecordIdString
	snapshot: null | Tsnapshot
	source_id?: string
	source_type: BusinessFinanceLedgerSourceTypeOptions
	tax_minor?: number
}

export type BusinessFollowsRecord = {
	business_id: RecordIdString
	created: IsoAutoDateString
	follower_id: RecordIdString
	id: string
	notify_availability?: boolean
	notify_events?: boolean
	notify_posts?: boolean
	notify_sessions?: boolean
	updated: IsoAutoDateString
}

export enum BusinessMessagesStatusOptions {
	"visible" = "visible",
	"removed" = "removed",
}
export type BusinessMessagesRecord = {
	attachments?: FileNameString[]
	body: HTMLString
	conversation_id: RecordIdString
	created: IsoAutoDateString
	id: string
	read_at?: IsoDateString
	sender_id: RecordIdString
	status: BusinessMessagesStatusOptions
	updated: IsoAutoDateString
}

export enum BusinessPilotAuditTargetTypeOptions {
	"pilot" = "pilot",
	"flag" = "flag",
	"roster" = "roster",
	"support_case" = "support_case",
}
export type BusinessPilotAuditRecord<Tafter_state = unknown, Tbefore_state = unknown> = {
	action: string
	actor_id: RecordIdString
	after_state?: null | Tafter_state
	before_state?: null | Tbefore_state
	created: IsoAutoDateString
	id: string
	reason: string
	retain_until: IsoDateString
	target_id: string
	target_type: BusinessPilotAuditTargetTypeOptions
}

export enum BusinessPilotProgramsStateOptions {
	"draft" = "draft",
	"active" = "active",
	"paused" = "paused",
	"graduated" = "graduated",
	"shutdown" = "shutdown",
}

export enum BusinessPilotProgramsDecisionOptions {
	"pending" = "pending",
	"graduate" = "graduate",
	"iterate" = "iterate",
	"shutdown" = "shutdown",
}
export type BusinessPilotProgramsRecord<Tthresholds = unknown> = {
	created: IsoAutoDateString
	decided_at?: IsoDateString
	decision: BusinessPilotProgramsDecisionOptions
	decision_notes?: string
	id: string
	key: string
	name: string
	owner_id: RecordIdString
	rationale: string
	review_at: IsoDateString
	state: BusinessPilotProgramsStateOptions
	thresholds: null | Tthresholds
	updated: IsoAutoDateString
}

export enum BusinessPilotRosterStatusOptions {
	"invited" = "invited",
	"active" = "active",
	"paused" = "paused",
	"exited" = "exited",
}
export type BusinessPilotRosterRecord = {
	added_by_id: RecordIdString
	business_id: RecordIdString
	created: IsoAutoDateString
	exited_at?: IsoDateString
	id: string
	joined_at?: IsoDateString
	pilot_id: RecordIdString
	reason: string
	status: BusinessPilotRosterStatusOptions
	updated: IsoAutoDateString
}

export enum BusinessPlansBillingPeriodOptions {
	"none" = "none",
	"month" = "month",
	"year" = "year",
}
export type BusinessPlansRecord<Tentitlements = unknown, Tname = unknown> = {
	active?: boolean
	billing_period: BusinessPlansBillingPeriodOptions
	code: string
	created: IsoAutoDateString
	currency: string
	entitlements?: null | Tentitlements
	id: string
	name: null | Tname
	price_minor?: number
	trial_days?: number
	updated: IsoAutoDateString
	vat_basis_points?: number
	version: number
}

export enum BusinessPostCommentsStatusOptions {
	"visible" = "visible",
	"removed" = "removed",
}
export type BusinessPostCommentsRecord = {
	attachments?: FileNameString[]
	author_id: RecordIdString
	body: HTMLString
	business_reply?: boolean
	created: IsoAutoDateString
	id: string
	post_id: RecordIdString
	status: BusinessPostCommentsStatusOptions
	updated: IsoAutoDateString
}

export enum BusinessPostsStatusOptions {
	"published" = "published",
	"closed" = "closed",
	"removed" = "removed",
}
export type BusinessPostsRecord = {
	attachments?: FileNameString[]
	author_id: RecordIdString
	body: HTMLString
	business_id: RecordIdString
	created: IsoAutoDateString
	id: string
	published_at?: IsoDateString
	status: BusinessPostsStatusOptions
	title?: string
	updated: IsoAutoDateString
}

export enum BusinessReconciliationExceptionsKindOptions {
	"missing_ledger" = "missing_ledger",
	"amount_mismatch" = "amount_mismatch",
	"status_mismatch" = "status_mismatch",
	"settlement_variance" = "settlement_variance",
}

export enum BusinessReconciliationExceptionsStatusOptions {
	"open" = "open",
	"acknowledged" = "acknowledged",
	"resolved" = "resolved",
}
export type BusinessReconciliationExceptionsRecord<Tdetails = unknown> = {
	actual_minor?: number
	business_id: RecordIdString
	created: IsoAutoDateString
	details?: null | Tdetails
	detected_at: IsoDateString
	exception_key: string
	expected_minor?: number
	id: string
	kind: BusinessReconciliationExceptionsKindOptions
	provider_reference?: string
	resolution_note?: string
	resolved_at?: IsoDateString
	resolved_by_id?: RecordIdString
	status: BusinessReconciliationExceptionsStatusOptions
	updated: IsoAutoDateString
}

export enum BusinessResourcesKindOptions {
	"room" = "room",
	"court" = "court",
	"table" = "table",
	"equipment" = "equipment",
	"instructor" = "instructor",
	"other" = "other",
}
export type BusinessResourcesRecord = {
	active?: boolean
	buffer_after_minutes?: number
	buffer_before_minutes?: number
	business_id: RecordIdString
	cancellation_terms?: string
	capacity: number
	created: IsoAutoDateString
	currency?: string
	description?: string
	exclusive?: boolean
	id: string
	kind: BusinessResourcesKindOptions
	maximum_duration_minutes: number
	minimum_duration_minutes: number
	name: string
	price_minor_per_slot?: number
	slot_step_minutes: number
	timezone: string
	updated: IsoAutoDateString
}

export enum BusinessSettlementsStatusOptions {
	"pending" = "pending",
	"settled" = "settled",
	"failed" = "failed",
}
export type BusinessSettlementsRecord<Tprovider_snapshot = unknown> = {
	business_id: RecordIdString
	created: IsoAutoDateString
	currency: string
	fee_minor: number
	gross_minor: number
	id: string
	net_minor: number
	provider: string
	provider_settlement_id: string
	provider_snapshot: null | Tprovider_snapshot
	refund_minor: number
	retain_until: IsoDateString
	settled_at: IsoDateString
	status: BusinessSettlementsStatusOptions
}

export type BusinessSubscriptionEventsRecord<Tdetails = unknown> = {
	business_id: RecordIdString
	created: IsoAutoDateString
	details?: null | Tdetails
	event_type: string
	from_status?: string
	id: string
	occurred_at: IsoDateString
	provider_event_id: string
	subscription_id: RecordIdString
	to_status?: string
}

export enum BusinessSubscriptionInvoicesStatusOptions {
	"paid" = "paid",
	"refunded" = "refunded",
}
export type BusinessSubscriptionInvoicesRecord<Tsnapshot = unknown> = {
	business_id: RecordIdString
	created: IsoAutoDateString
	currency: string
	id: string
	invoice_number: string
	issued_at: IsoDateString
	provider_charge_id: string
	retain_until: IsoDateString
	snapshot: null | Tsnapshot
	status: BusinessSubscriptionInvoicesStatusOptions
	subscription_id: RecordIdString
	subtotal_minor: number
	total_minor: number
	vat_minor: number
}

export enum BusinessSubscriptionsStatusOptions {
	"pending" = "pending",
	"trialing" = "trialing",
	"active" = "active",
	"grace" = "grace",
	"past_due" = "past_due",
	"cancel_scheduled" = "cancel_scheduled",
	"canceled" = "canceled",
	"expired" = "expired",
}
export type BusinessSubscriptionsRecord = {
	business_id: RecordIdString
	cancel_at?: IsoDateString
	checkout_idempotency_key: string
	created: IsoAutoDateString
	current_period_end?: IsoDateString
	current_period_start?: IsoDateString
	failure_code?: string
	grace_ends_at?: IsoDateString
	id: string
	last_provider_event_at?: IsoDateString
	plan_id: RecordIdString
	provider: string
	provider_agreement_id?: string
	status: BusinessSubscriptionsStatusOptions
	trial_ends_at?: IsoDateString
	updated: IsoAutoDateString
}

export enum BusinessSupportCasesStatusOptions {
	"open" = "open",
	"investigating" = "investigating",
	"waiting" = "waiting",
	"resolved" = "resolved",
	"closed" = "closed",
}

export enum BusinessSupportCasesPriorityOptions {
	"low" = "low",
	"normal" = "normal",
	"high" = "high",
	"urgent" = "urgent",
}

export enum BusinessSupportCasesSourceTypeOptions {
	"none" = "none",
	"booking" = "booking",
	"payment" = "payment",
	"subscription" = "subscription",
	"reconciliation" = "reconciliation",
}
export type BusinessSupportCasesRecord<Tdiagnostic_context = unknown> = {
	assigned_to_id?: RecordIdString
	business_id?: RecordIdString
	category: string
	created: IsoAutoDateString
	diagnostic_context?: null | Tdiagnostic_context
	id: string
	priority: BusinessSupportCasesPriorityOptions
	reference: string
	requester_id?: RecordIdString
	resolution?: string
	resolved_at?: IsoDateString
	retain_until: IsoDateString
	source_id?: string
	source_type: BusinessSupportCasesSourceTypeOptions
	status: BusinessSupportCasesStatusOptions
	summary: string
	updated: IsoAutoDateString
}

export enum ClientDiagnosticRateBucketsScopeOptions {
	"subject" = "subject",
	"global" = "global",
}
export type ClientDiagnosticRateBucketsRecord = {
	count: number
	created: IsoAutoDateString
	id: string
	scope: ClientDiagnosticRateBucketsScopeOptions
	subject_hash: string
	updated: IsoAutoDateString
	window_start: IsoDateString
}

export enum ClientDiagnosticsLevelOptions {
	"warning" = "warning",
	"error" = "error",
}

export enum ClientDiagnosticsSourceOptions {
	"console" = "console",
	"vue" = "vue",
	"router" = "router",
	"window" = "window",
}
export type ClientDiagnosticsRecord = {
	browser?: string
	created: IsoAutoDateString
	fingerprint: string
	id: string
	level: ClientDiagnosticsLevelOptions
	message: string
	platform?: string
	release?: string
	route?: string
	source: ClientDiagnosticsSourceOptions
	stack?: string
	user_id?: RecordIdString
}

export type ContactDiscoveryRequestsRecord = {
	created: IsoAutoDateString
	id: string
	identifier_count: number
	user_id: RecordIdString
}

export type CountriesRecord = {
	created: IsoAutoDateString
	id: string
	iso3?: string
	iso: string
	name: string
	nicename: string
	numcode?: number
	phonecode?: number
	updated: IsoAutoDateString
}

export enum CustomerReceiptsSourceTypeOptions {
	"event_payment" = "event_payment",
	"resource_booking" = "resource_booking",
}

export enum CustomerReceiptsStatusOptions {
	"issued" = "issued",
	"refund_pending" = "refund_pending",
	"refunded" = "refunded",
}
export type CustomerReceiptsRecord<Tsnapshot = unknown> = {
	amount_minor: number
	created: IsoAutoDateString
	currency: string
	customer_id?: RecordIdString
	customer_subject_hash: string
	id: string
	issued_at: IsoDateString
	receipt_number: string
	retain_until: IsoDateString
	snapshot: null | Tsnapshot
	source_id: string
	source_type: CustomerReceiptsSourceTypeOptions
	status: CustomerReceiptsStatusOptions
	support_reference: string
	updated: IsoAutoDateString
}

export enum EphemeralRsvpsStatusOptions {
	"going" = "going",
	"waitlisted" = "waitlisted",
}
export type EphemeralRsvpsRecord = {
	created: IsoAutoDateString
	display_name: string
	email?: string
	event_id: RecordIdString
	expires_at: IsoDateString
	id: string
	status: EphemeralRsvpsStatusOptions
	token_hash: string
	updated: IsoAutoDateString
	waitlisted_at?: IsoDateString
}

export enum EventAgeProfilesCompanyGenderOptions {
	"woman" = "woman",
	"man" = "man",
	"prefer_not_to_say" = "prefer_not_to_say",
}
export type EventAgeProfilesRecord = {
	birth_date: IsoDateString
	company_gender?: EventAgeProfilesCompanyGenderOptions
	id: string
	user_id: RecordIdString
}

export type EventAnticipationOptionsRecord = {
	id: string
	label_en: string
	label_nb?: string
	position: number
	prompt_id: RecordIdString
}

export enum EventAnticipationPromptsKindOptions {
	"icebreaker" = "icebreaker",
	"poll" = "poll",
}

export enum EventAnticipationPromptsRecurrenceScopeOptions {
	"occurrence" = "occurrence",
	"series" = "series",
}

export enum EventAnticipationPromptsStatusOptions {
	"open" = "open",
	"closed" = "closed",
}
export type EventAnticipationPromptsRecord = {
	closes_at?: IsoDateString
	created: IsoAutoDateString
	creator_id: RecordIdString
	event_id: RecordIdString
	event_key: string
	id: string
	kind: EventAnticipationPromptsKindOptions
	opens_at?: IsoDateString
	prompt_en: string
	prompt_nb?: string
	recurrence_scope: EventAnticipationPromptsRecurrenceScopeOptions
	series_key?: string
	status: EventAnticipationPromptsStatusOptions
	updated: IsoAutoDateString
}

export enum EventAnticipationResponsesAudienceOptions {
	"attendees" = "attendees",
}

export enum EventAnticipationResponsesStatusOptions {
	"visible" = "visible",
	"hidden" = "hidden",
}
export type EventAnticipationResponsesRecord = {
	audience: EventAnticipationResponsesAudienceOptions
	created: IsoAutoDateString
	event_key: string
	id: string
	option_id?: RecordIdString
	prompt_id: RecordIdString
	status: EventAnticipationResponsesStatusOptions
	text?: string
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export type EventAnticipationStateRecord = {
	created: IsoAutoDateString
	dismissed_at: IsoAutoDateString
	event_key: string
	id: string
	prompt_id: RecordIdString
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export type EventBookmarksRecord = {
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export type EventChatsRecord = {
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	message: string
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export type EventChatsViewRecord = {
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	message: string
	updated: IsoAutoDateString
	user_avatar?: FileNameString
	user_id: RecordIdString
	user_name: string
}

export enum EventCheckInAuditActionOptions {
	"check_in" = "check_in",
	"duplicate_scan" = "duplicate_scan",
	"reversal" = "reversal",
	"revocation" = "revocation",
	"verification_override" = "verification_override",
}
export type EventCheckInAuditRecord = {
	action: EventCheckInAuditActionOptions
	actor_id: RecordIdString
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	reason?: string
	ticket_id: RecordIdString
}

export type EventCompanyBlocksRecord = {
	blocked_id: RecordIdString
	blocker_id: RecordIdString
	created: IsoAutoDateString
	id: string
}

export type EventCompanyMatchesRecord = {
	created: IsoAutoDateString
	event_id: RecordIdString
	expires_at: IsoDateString
	id: string
	user_a_id: RecordIdString
	user_b_id: RecordIdString
}

export type EventCompanyMessagesRecord = {
	attachments?: FileNameString[]
	body?: string
	created: IsoAutoDateString
	id: string
	room_id: RecordIdString
	sender_id: RecordIdString
	submission_id: string
}

export enum EventCompanyOptInsStatusOptions {
	"open" = "open",
	"matched" = "matched",
}

export enum EventCompanyOptInsConversationPreferenceOptions {
	"either" = "either",
	"quiet" = "quiet",
	"chatty" = "chatty",
}

export enum EventCompanyOptInsPreferredGenderOptions {
	"any" = "any",
	"woman" = "woman",
	"man" = "man",
}
export type EventCompanyOptInsRecord = {
	conversation_preference: EventCompanyOptInsConversationPreferenceOptions
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	maximum_age?: number
	minimum_age?: number
	preferred_gender?: EventCompanyOptInsPreferredGenderOptions
	room_id?: RecordIdString
	status: EventCompanyOptInsStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export type EventCompanyRateLimitsRecord = {
	action: string
	actor_id: RecordIdString
	count: number
	id: string
	window_start: IsoDateString
}

export enum EventCompanyReactionsEmojiOptions {
	"👍" = "👍",
	"❤️" = "❤️",
	"😂" = "😂",
	"😮" = "😮",
	"😢" = "😢",
}
export type EventCompanyReactionsRecord = {
	created: IsoAutoDateString
	emoji: EventCompanyReactionsEmojiOptions
	id: string
	message_id: RecordIdString
	room_id: RecordIdString
	user_id: RecordIdString
}

export enum EventCompanyReportsStatusOptions {
	"pending" = "pending",
	"reviewed" = "reviewed",
}
export type EventCompanyReportsRecord = {
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	reason: string
	reported_id: RecordIdString
	reporter_id: RecordIdString
	status: EventCompanyReportsStatusOptions
}

export type EventCompanyRoomMembersRecord = {
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	joined_at: IsoDateString
	last_read_at?: IsoDateString
	last_read_message_id?: RecordIdString
	left_at?: IsoDateString
	room_id: RecordIdString
	typing_until?: IsoDateString
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export type EventCompanyRoomSignalsRecord = {
	id: string
	room_id: RecordIdString
	updated: IsoAutoDateString
	version: number
}

export enum EventCompanyRoomsStatusOptions {
	"open" = "open",
	"closed" = "closed",
}
export type EventCompanyRoomsRecord = {
	created: IsoAutoDateString
	event_id: RecordIdString
	expires_at: IsoDateString
	id: string
	purge_at: IsoDateString
	status: EventCompanyRoomsStatusOptions
	updated: IsoAutoDateString
}

export enum EventContentReportsTargetTypeOptions {
	"post" = "post",
	"comment" = "comment",
	"chat" = "chat",
	"anticipation_response" = "anticipation_response",
}

export enum EventContentReportsStatusOptions {
	"pending" = "pending",
	"reviewed" = "reviewed",
	"dismissed" = "dismissed",
}
export type EventContentReportsRecord = {
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	reason?: string
	reporter_id: RecordIdString
	status?: EventContentReportsStatusOptions
	target_id: string
	target_type: EventContentReportsTargetTypeOptions
	updated: IsoAutoDateString
}

export type EventFeedbackRecord = {
	accessibility_accuracy: number
	created: IsoAutoDateString
	description_accuracy: number
	event_id: RecordIdString
	id: string
	overall: number
	return_likelihood: number
	safety: number
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export type EventImpressionsRecord = {
	created: IsoAutoDateString
	day: IsoDateString
	dedupe_key: string
	event_id: RecordIdString
	id: string
}

export enum EventMembersStatusOptions {
	"maybe" = "maybe",
	"going" = "going",
	"not_going" = "not_going",
	"waitlisted" = "waitlisted",
	"requested" = "requested",
	"offered" = "offered",
}

export enum EventMembersRoleOptions {
	"participant" = "participant",
	"host" = "host",
}

export enum EventMembersWaitlistModeOptions {
	"automatic" = "automatic",
	"confirm" = "confirm",
}
export type EventMembersRecord = {
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	role: EventMembersRoleOptions
	status: EventMembersStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
	waitlist_mode?: EventMembersWaitlistModeOptions
	waitlist_offer_expires_at?: IsoDateString
	waitlisted_at?: IsoDateString
}

export type EventMemoriesRecord = {
	created: IsoAutoDateString
	event_address?: string
	event_ends_at?: IsoDateString
	event_id?: RecordIdString
	event_key: string
	event_starts_at: IsoDateString
	event_timezone?: string
	event_title: string
	favorite_host?: boolean
	host_id?: RecordIdString
	host_name?: string
	id: string
	note?: string
	photos?: FileNameString[]
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export enum EventNotificationDeliveriesKindOptions {
	"reminder" = "reminder",
	"material_change" = "material_change",
	"departure_reminder" = "departure_reminder",
}
export type EventNotificationDeliveriesRecord = {
	created: IsoAutoDateString
	delivery_key: string
	event_id: RecordIdString
	id: string
	kind: EventNotificationDeliveriesKindOptions
	scheduled_for?: IsoDateString
	user_id: RecordIdString
}

export enum EventOrganizerAuditActionOptions {
	"invited" = "invited",
	"accepted" = "accepted",
	"declined" = "declined",
	"capabilities_changed" = "capabilities_changed",
	"removed" = "removed",
	"resigned" = "resigned",
	"revoked" = "revoked",
	"ownership_transferred" = "ownership_transferred",
	"capability_used" = "capability_used",
}
export type EventOrganizerAuditRecord<Tafter = unknown, Tbefore = unknown> = {
	action: EventOrganizerAuditActionOptions
	actor_hash: string
	after?: null | Tafter
	assignment_key?: string
	before?: null | Tbefore
	created: IsoAutoDateString
	event_key: string
	id: string
	reason?: string
	subject_hash?: string
}

export enum EventOrganizersStatusOptions {
	"pending" = "pending",
	"accepted" = "accepted",
	"declined" = "declined",
	"removed" = "removed",
	"resigned" = "resigned",
	"revoked" = "revoked",
}

export enum EventOrganizersScopeOptions {
	"occurrence" = "occurrence",
	"series" = "series",
}

export enum EventOrganizersCapabilitiesOptions {
	"edit_event" = "edit_event",
	"invite_attendees" = "invite_attendees",
	"review_join_requests" = "review_join_requests",
	"manage_attendees" = "manage_attendees",
	"moderate_content" = "moderate_content",
	"scan_tickets" = "scan_tickets",
	"view_analytics" = "view_analytics",
}
export type EventOrganizersRecord = {
	accepted_at?: IsoDateString
	capabilities: EventOrganizersCapabilitiesOptions[]
	created: IsoAutoDateString
	end_reason?: string
	ended_at?: IsoDateString
	event_id?: RecordIdString
	id: string
	invited_by_id?: RecordIdString
	scope: EventOrganizersScopeOptions
	series_id?: RecordIdString
	status: EventOrganizersStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export enum EventPlanOptionsKindOptions {
	"event" = "event",
	"custom" = "custom",
}
export type EventPlanOptionsRecord = {
	created: IsoAutoDateString
	custom_place?: string
	custom_title?: string
	event_id?: RecordIdString
	id: string
	kind: EventPlanOptionsKindOptions
	note?: string
	plan_id: RecordIdString
	proposed_by_id: RecordIdString
	proposed_ends_at?: IsoDateString
	proposed_starts_at?: IsoDateString
	updated: IsoAutoDateString
}

export enum EventPlanParticipantsStatusOptions {
	"invited" = "invited",
	"accepted" = "accepted",
	"declined" = "declined",
	"left" = "left",
}
export type EventPlanParticipantsRecord = {
	created: IsoAutoDateString
	id: string
	invited_by_id: RecordIdString
	plan_id: RecordIdString
	status: EventPlanParticipantsStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export enum EventPlanVotesValueOptions {
	"yes" = "yes",
	"maybe" = "maybe",
	"no" = "no",
}
export type EventPlanVotesRecord = {
	created: IsoAutoDateString
	id: string
	option_id: RecordIdString
	updated: IsoAutoDateString
	value: EventPlanVotesValueOptions
	voter_id: RecordIdString
}

export enum EventPlansStatusOptions {
	"draft" = "draft",
	"voting" = "voting",
	"selected" = "selected",
	"cancelled" = "cancelled",
}

export enum EventPlansVoteVisibilityOptions {
	"hidden_until_closed" = "hidden_until_closed",
	"live_totals" = "live_totals",
	"live_named" = "live_named",
}
export type EventPlansRecord<Tsearch_preferences = unknown> = {
	closes_at?: IsoDateString
	created: IsoAutoDateString
	draft_participant_ids?: RecordIdString[]
	id: string
	owner_id: RecordIdString
	search_preferences?: null | Tsearch_preferences
	selected_event_id?: RecordIdString
	selected_option_id?: RecordIdString
	status: EventPlansStatusOptions
	title: string
	updated: IsoAutoDateString
	vote_visibility: EventPlansVoteVisibilityOptions
}

export type EventPostCommentsRecord = {
	author_id: RecordIdString
	content_photos?: FileNameString[]
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	post_id: RecordIdString
	text_content: string
	updated: IsoAutoDateString
}

export type EventPostCommentsViewRecord = {
	author_avatar?: FileNameString
	author_id: RecordIdString
	author_name: string
	content_photos?: FileNameString[]
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	post_id: RecordIdString
	text_content: string
	updated: IsoAutoDateString
}

export type EventPostsRecord = {
	author_id: RecordIdString
	content_photos?: FileNameString[]
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	text_content: string
	timezone_id: RecordIdString
	updated: IsoAutoDateString
}

export type EventPostsViewRecord = {
	author_avatar?: FileNameString
	author_id: RecordIdString
	author_name: string
	comments_count?: number
	content_photos?: FileNameString[]
	created: IsoAutoDateString
	event_id: RecordIdString
	id: string
	text_content: string
	timezone: string
	updated: IsoAutoDateString
}

export enum EventRefundRequestsStatusOptions {
	"pending" = "pending",
	"approved" = "approved",
	"denied" = "denied",
	"resolved" = "resolved",
}
export type EventRefundRequestsRecord = {
	attempt_id: RecordIdString
	created: IsoAutoDateString
	decided_at?: IsoDateString
	decided_by?: RecordIdString
	decision_note?: string
	event_id: RecordIdString
	id: string
	reason: string
	requester_id: RecordIdString
	status: EventRefundRequestsStatusOptions
	updated: IsoAutoDateString
}

export enum EventSeriesFrequencyOptions {
	"daily" = "daily",
	"weekly" = "weekly",
	"monthly" = "monthly",
}

export enum EventSeriesEndTypeOptions {
	"count" = "count",
	"until" = "until",
}
export type EventSeriesRecord<Tadded_dates = unknown, Texcluded_dates = unknown, Tweekdays = unknown> = {
	added_dates?: null | Tadded_dates
	created: IsoAutoDateString
	end_type: EventSeriesEndTypeOptions
	excluded_dates?: null | Texcluded_dates
	frequency: EventSeriesFrequencyOptions
	host: RecordIdString
	id: string
	interval: number
	month_day?: number
	occurrence_count?: number
	timezone: string
	until?: IsoDateString
	updated: IsoAutoDateString
	weekdays?: null | Tweekdays
}

export enum EventTicketChallengesStatusOptions {
	"active" = "active",
	"consumed" = "consumed",
	"expired" = "expired",
	"superseded" = "superseded",
	"overridden" = "overridden",
}
export type EventTicketChallengesRecord = {
	completed_at?: IsoDateString
	created: IsoAutoDateString
	event_id: RecordIdString
	expires_at: IsoDateString
	id: string
	organizer_id: RecordIdString
	status: EventTicketChallengesStatusOptions
	ticket_id: RecordIdString
	updated: IsoAutoDateString
	verification_token?: string
}

export enum EventTicketTransfersStatusOptions {
	"offered" = "offered",
	"payment_pending" = "payment_pending",
	"completing" = "completing",
	"completed" = "completed",
	"declined" = "declined",
	"withdrawn" = "withdrawn",
	"expired" = "expired",
	"failed" = "failed",
}
export type EventTicketTransfersRecord = {
	completed_at?: IsoDateString
	created: IsoAutoDateString
	event_id: RecordIdString
	failure_reason?: string
	id: string
	offer_expires_at: IsoDateString
	recipient_id: RecordIdString
	replacement_attempt_id?: RecordIdString
	sender_id: RecordIdString
	source_attempt_id: RecordIdString
	status: EventTicketTransfersStatusOptions
	updated: IsoAutoDateString
}

export enum EventTicketsStatusOptions {
	"active" = "active",
	"checked_in" = "checked_in",
	"revoked" = "revoked",
}
export type EventTicketsRecord = {
	checked_in_at?: IsoDateString
	checked_in_by?: RecordIdString
	created: IsoAutoDateString
	email_attempts?: number
	email_last_error?: string
	email_sent_at?: IsoDateString
	ephemeral_rsvp_id?: RecordIdString
	event_id: RecordIdString
	id: string
	membership_id?: RecordIdString
	revoked_reason?: string
	status: EventTicketsStatusOptions
	token: string
	updated: IsoAutoDateString
	user_id?: RecordIdString
}

export enum EventViewEventKindOptions {
	"standard" = "standard",
	"parent" = "parent",
	"sub_event" = "sub_event",
}

export enum EventViewEnvironmentOptions {
	"unspecified" = "unspecified",
	"indoor" = "indoor",
	"outdoor" = "outdoor",
	"mixed" = "mixed",
}

export enum EventViewOccurrenceStatusOptions {
	"scheduled" = "scheduled",
	"cancelled" = "cancelled",
}

export enum EventViewCancellationRefundPolicyOptions {
	"automatic" = "automatic",
	"manual" = "manual",
}

export enum EventViewRescheduleRefundPolicyOptions {
	"automatic" = "automatic",
	"manual" = "manual",
}
export type EventViewRecord<Tattending_avatars_sample = unknown, Tattending_count = unknown, Tgeojson = unknown> = {
	address: string
	attendance_ticket_enabled?: boolean
	attending_avatars_sample?: null | Tattending_avatars_sample
	attending_count?: null | Tattending_count
	booking_url?: string
	cancellation_refund_policy?: EventViewCancellationRefundPolicyOptions
	category_id: RecordIdString
	chat_enabled?: boolean
	created: IsoAutoDateString
	description: string
	ends_at?: IsoDateString
	environment: EventViewEnvironmentOptions
	event_kind?: EventViewEventKindOptions
	family_friendly?: boolean
	geojson?: null | Tgeojson
	group_avatar: FileNameString
	group_id?: RecordIdString
	group_name: string
	host_avatar?: FileNameString
	host_count?: number
	host_id: RecordIdString
	host_is_venue?: boolean
	host_is_verified?: boolean
	host_name: string
	host_venue_address?: string
	host_venue_hours?: string
	host_venue_location?: GeoPoint
	host_venue_phone?: string
	host_venue_website?: string
	id: string
	invitation_enabled?: boolean
	invited_count?: number
	join_moderation_enabled?: boolean
	location: GeoPoint
	maximum_age?: number
	minimum_age?: number
	occurrence_status?: EventViewOccurrenceStatusOptions
	parent_event_id?: RecordIdString
	photos?: FileNameString[]
	price?: number
	price_currency?: string
	public_event?: boolean
	refund_cutoff_minutes?: number
	reschedule_refund_policy?: EventViewRescheduleRefundPolicyOptions
	reschedule_refund_until?: IsoDateString
	series_id?: RecordIdString
	starts_at: IsoDateString
	ticket_transfer_cutoff_minutes?: number
	timezone: string
	title: string
	updated: IsoAutoDateString
	wheelchair_accessible?: boolean
}

export enum EventsOccurrenceStatusOptions {
	"scheduled" = "scheduled",
	"cancelled" = "cancelled",
}

export enum EventsPlatformStatusOptions {
	"active" = "active",
	"restricted" = "restricted",
}

export enum EventsEventKindOptions {
	"standard" = "standard",
	"parent" = "parent",
	"sub_event" = "sub_event",
}

export enum EventsEnvironmentOptions {
	"unspecified" = "unspecified",
	"indoor" = "indoor",
	"outdoor" = "outdoor",
	"mixed" = "mixed",
}

export enum EventsCancellationRefundPolicyOptions {
	"automatic" = "automatic",
	"manual" = "manual",
}

export enum EventsRescheduleRefundPolicyOptions {
	"automatic" = "automatic",
	"manual" = "manual",
}
export type EventsRecord<Tgeojson = unknown, Tnotification_settings = unknown> = {
	address: string
	attendance_ticket_enabled?: boolean
	auto_cancel_enabled?: boolean
	booking_url?: string
	cancellation_refund_policy?: EventsCancellationRefundPolicyOptions
	category_id: RecordIdString
	chat_enabled?: boolean
	created: IsoAutoDateString
	description: string
	ends_at?: IsoDateString
	environment: EventsEnvironmentOptions
	event_kind?: EventsEventKindOptions
	family_friendly?: boolean
	geojson?: null | Tgeojson
	group_id?: RecordIdString
	host: RecordIdString
	id: string
	import_url?: string
	invitation_enabled?: boolean
	join_moderation_enabled?: boolean
	location: GeoPoint
	maximum_age?: number
	maximum_attendees?: number
	media_retention_extended?: boolean
	minimum_age?: number
	minimum_attendees?: number
	notification_settings?: null | Tnotification_settings
	occurrence_start?: IsoDateString
	occurrence_status?: EventsOccurrenceStatusOptions
	parent_event_id?: RecordIdString
	photos?: FileNameString[]
	platform_restricted_at?: IsoDateString
	platform_restriction_reason?: string
	platform_status?: EventsPlatformStatusOptions
	price?: number
	price_currency?: string
	public_event?: boolean
	refund_cutoff_minutes?: number
	refund_terms?: string
	reschedule_refund_policy?: EventsRescheduleRefundPolicyOptions
	reschedule_refund_until?: IsoDateString
	series_id?: RecordIdString
	signup_closes_at?: IsoDateString
	speaker?: string
	starts_at: IsoDateString
	ticket_transfer_cutoff_minutes?: number
	timezone: RecordIdString
	title: string
	updated: IsoAutoDateString
	vipps_payment_required?: boolean
	wait_list_enabled?: boolean
	waitlist_confirmation_minutes?: number
	wheelchair_accessible?: boolean
}

export enum EventsViewEventKindOptions {
	"standard" = "standard",
	"parent" = "parent",
	"sub_event" = "sub_event",
}

export enum EventsViewOccurrenceStatusOptions {
	"scheduled" = "scheduled",
	"cancelled" = "cancelled",
}

export enum EventsViewEnvironmentOptions {
	"unspecified" = "unspecified",
	"indoor" = "indoor",
	"outdoor" = "outdoor",
	"mixed" = "mixed",
}
export type EventsViewRecord<Tattending_avatars_sample = unknown, Tattending_count = unknown, Tphoto = unknown> = {
	address: string
	attending_avatars_sample?: null | Tattending_avatars_sample
	attending_count?: null | Tattending_count
	category_id: RecordIdString
	created: IsoAutoDateString
	description: string
	ends_at?: IsoDateString
	environment: EventsViewEnvironmentOptions
	event_kind?: EventsViewEventKindOptions
	family_friendly?: boolean
	group_id?: RecordIdString
	group_name: string
	group_photo: FileNameString
	host_avatar?: FileNameString
	host_count?: number
	host_id: RecordIdString
	host_is_venue?: boolean
	host_is_verified?: boolean
	host_name: string
	host_venue_address?: string
	host_venue_hours?: string
	host_venue_location?: GeoPoint
	host_venue_phone?: string
	host_venue_website?: string
	id: string
	invited_count?: number
	location: GeoPoint
	occurrence_status?: EventsViewOccurrenceStatusOptions
	parent_event_id?: RecordIdString
	photo?: null | Tphoto
	public_event?: boolean
	series_id?: RecordIdString
	starts_at: IsoDateString
	timezone: string
	title: string
	wheelchair_accessible?: boolean
}

export enum FeatureFlagsCategoryOptions {
	"platform_integrations" = "platform_integrations",
	"discovery_social" = "discovery_social",
	"event_group" = "event_group",
	"business" = "business",
}
export type FeatureFlagsRecord = {
	category: FeatureFlagsCategoryOptions
	created: IsoAutoDateString
	description?: string
	enabled?: boolean
	id: string
	key: string
	name: string
	updated: IsoAutoDateString
}

export type GroupCategoriesRecord = {
	created: IsoAutoDateString
	icon: string
	id: string
	name: string
	updated: IsoAutoDateString
}

export type GroupInviteLinksRecord = {
	created: IsoAutoDateString
	created_by_id: RecordIdString
	expires_at: IsoDateString
	group_id: RecordIdString
	id: string
	max_uses?: number
	revoked?: boolean
	token_hash: string
	updated: IsoAutoDateString
	use_count?: number
}

export enum GroupMembersStatusOptions {
	"invited" = "invited",
	"accepted" = "accepted",
	"declined" = "declined",
	"banned" = "banned",
	"requested" = "requested",
}

export enum GroupMembersRoleOptions {
	"member" = "member",
	"admin" = "admin",
	"owner" = "owner",
}

export enum GroupMembersJoinSourceOptions {
	"direct" = "direct",
	"in_app_invitation" = "in_app_invitation",
	"invite_link" = "invite_link",
}
export type GroupMembersRecord = {
	admin_approved?: boolean
	created: IsoAutoDateString
	group_id: RecordIdString
	id: string
	invited_by_id?: RecordIdString
	join_source?: GroupMembersJoinSourceOptions
	role: GroupMembersRoleOptions
	status: GroupMembersStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export enum GroupMembersViewStatusOptions {
	"invited" = "invited",
	"accepted" = "accepted",
	"declined" = "declined",
	"banned" = "banned",
	"requested" = "requested",
}

export enum GroupMembersViewRoleOptions {
	"member" = "member",
	"admin" = "admin",
	"owner" = "owner",
}
export type GroupMembersViewRecord = {
	group_id: RecordIdString
	id: string
	invited_by_avatar?: FileNameString
	invited_by_id?: RecordIdString
	invited_by_name: string
	role: GroupMembersViewRoleOptions
	status: GroupMembersViewStatusOptions
	user_avatar?: FileNameString
	user_id: RecordIdString
	user_name: string
}

export type GroupPostCommentsRecord = {
	author_id: RecordIdString
	content_photos?: FileNameString[]
	created: IsoAutoDateString
	group_id: RecordIdString
	id: string
	post_id: RecordIdString
	text_content: string
	updated: IsoAutoDateString
}

export type GroupPostCommentsViewRecord = {
	author_avatar?: FileNameString
	author_id: RecordIdString
	author_name: string
	content_photos?: FileNameString[]
	created: IsoAutoDateString
	id: string
	post_id: RecordIdString
	text_content: string
	updated: IsoAutoDateString
}

export type GroupPostsRecord = {
	author_id: RecordIdString
	content_photos?: FileNameString[]
	created: IsoAutoDateString
	group_id: RecordIdString
	id: string
	text_content: string
	timezone_id: RecordIdString
	updated: IsoAutoDateString
}

export type GroupPostsViewRecord = {
	author_avatar?: FileNameString
	author_id: RecordIdString
	author_name: string
	comments_count?: number
	content_photos?: FileNameString[]
	created: IsoAutoDateString
	group_id: RecordIdString
	id: string
	text_content: string
	timezone: string
	updated: IsoAutoDateString
}

export type GroupViewRecord<Tgeojson = unknown, Tmembers_avatar_sample = unknown> = {
	address?: string
	category_icon: string
	category_id?: RecordIdString
	category_name: string
	chat_enabled?: boolean
	created: IsoAutoDateString
	description: string
	events_count?: number
	geojson?: null | Tgeojson
	id: string
	location?: GeoPoint
	members_avatar_sample?: null | Tmembers_avatar_sample
	members_can_create_events?: boolean
	members_can_create_posts?: boolean
	members_can_invite?: boolean
	members_count?: number
	members_must_be_approved?: boolean
	name: string
	owner_id: RecordIdString
	owner_name: string
	owner_photo?: FileNameString
	photo: FileNameString
	posts_count?: number
	posts_enabled?: boolean
	public_group?: boolean
	updated: IsoAutoDateString
}

export enum GroupsPlatformStatusOptions {
	"active" = "active",
	"restricted" = "restricted",
}
export type GroupsRecord<Tgeojson = unknown> = {
	address?: string
	category_id?: RecordIdString
	chat_enabled?: boolean
	created: IsoAutoDateString
	description: string
	geojson?: null | Tgeojson
	id: string
	location?: GeoPoint
	members_can_create_events?: boolean
	members_can_create_posts?: boolean
	members_can_invite?: boolean
	members_must_be_approved?: boolean
	name: string
	owner: RecordIdString
	photo: FileNameString
	platform_restricted_at?: IsoDateString
	platform_restriction_reason?: string
	platform_status?: GroupsPlatformStatusOptions
	posts_enabled?: boolean
	public_group?: boolean
	updated: IsoAutoDateString
}

export type GroupsViewRecord<Tupcoming_event_count = unknown> = {
	address?: string
	category_icon: string
	category_id?: RecordIdString
	category_name: string
	created: IsoAutoDateString
	description: string
	id: string
	location?: GeoPoint
	members_count?: number
	name: string
	owner_id: RecordIdString
	owner_name: string
	owner_photo?: FileNameString
	photo: FileNameString
	public_group?: boolean
	upcoming_event_count?: null | Tupcoming_event_count
	updated: IsoAutoDateString
}

export type HostEventAnalyticsRecord<Tfeedback_accessibility = unknown, Tfeedback_count = unknown, Tfeedback_overall = unknown, Tfeedback_return = unknown, Tfeedback_safety = unknown, Timpressions = unknown> = {
	attended?: number
	feedback_accessibility?: null | Tfeedback_accessibility
	feedback_count?: null | Tfeedback_count
	feedback_overall?: null | Tfeedback_overall
	feedback_return?: null | Tfeedback_return
	feedback_safety?: null | Tfeedback_safety
	host_id: RecordIdString
	id: string
	impressions?: null | Timpressions
	maximum_attendees?: number
	no_shows?: number
	parent_event_id?: RecordIdString
	registrations?: number
	repeat_participants?: number
	series_id?: RecordIdString
	starts_at: IsoDateString
	title: string
	tz_code: string
	waitlisted?: number
}

export type HostReliabilitySignalsRecord<Taccessibility_accuracy = unknown, Tcancellation_rate = unknown, Tdescription_accuracy = unknown, Tpunctual_event_count = unknown, Tpunctuality_rate = unknown, Tverified_feedback_count = unknown> = {
	accessibility_accuracy?: null | Taccessibility_accuracy
	cancellation_rate?: null | Tcancellation_rate
	cancelled_event_count?: number
	completed_event_count?: number
	description_accuracy?: null | Tdescription_accuracy
	host_id: RecordIdString
	id: string
	punctual_event_count?: null | Tpunctual_event_count
	punctuality_rate?: null | Tpunctuality_rate
	verified_feedback_count?: null | Tverified_feedback_count
}

export enum LaunchEventsEventTypeOptions {
	"organizer_started" = "organizer_started",
	"group_created" = "group_created",
	"event_created" = "event_created",
	"invitation_sent" = "invitation_sent",
	"participant_responded" = "participant_responded",
}
export type LaunchEventsRecord = {
	actor_id?: RecordIdString
	campaign?: string
	created: IsoAutoDateString
	event_id?: RecordIdString
	event_type: LaunchEventsEventTypeOptions
	group_id?: RecordIdString
	id: string
	session_key?: string
	source?: string
}

export enum ModerationActionsActionOptions {
	"dismiss" = "dismiss",
	"warn" = "warn",
	"hide" = "hide",
	"suspend" = "suspend",
	"restore" = "restore",
	"escalate" = "escalate",
}

export enum ModerationActionsReasonCodeOptions {
	"no_violation" = "no_violation",
	"spam" = "spam",
	"harassment" = "harassment",
	"hate" = "hate",
	"violence" = "violence",
	"sexual_content" = "sexual_content",
	"misinformation" = "misinformation",
	"privacy" = "privacy",
	"impersonation" = "impersonation",
	"other" = "other",
}
export type ModerationActionsRecord = {
	action: ModerationActionsActionOptions
	actor_id: RecordIdString
	created: IsoAutoDateString
	id: string
	notes: string
	reason_code: ModerationActionsReasonCodeOptions
	report_id: RecordIdString
	target_id: string
	target_type: string
}

export enum ModerationAppealsStatusOptions {
	"pending" = "pending",
	"upheld" = "upheld",
	"overturned" = "overturned",
}
export type ModerationAppealsRecord = {
	action_id: RecordIdString
	appellant_id: RecordIdString
	created: IsoAutoDateString
	id: string
	response?: string
	reviewed_by?: RecordIdString
	statement: string
	status: ModerationAppealsStatusOptions
	updated: IsoAutoDateString
}

export enum ModerationReportsTargetTypeOptions {
	"post" = "post",
	"comment" = "comment",
	"chat" = "chat",
	"event" = "event",
	"group" = "group",
	"venue" = "venue",
	"user" = "user",
	"anticipation_response" = "anticipation_response",
}

export enum ModerationReportsReasonCodeOptions {
	"spam" = "spam",
	"harassment" = "harassment",
	"hate" = "hate",
	"violence" = "violence",
	"sexual_content" = "sexual_content",
	"misinformation" = "misinformation",
	"privacy" = "privacy",
	"impersonation" = "impersonation",
	"other" = "other",
}

export enum ModerationReportsStatusOptions {
	"pending" = "pending",
	"assigned" = "assigned",
	"investigating" = "investigating",
	"resolved" = "resolved",
	"dismissed" = "dismissed",
	"escalated" = "escalated",
}

export enum ModerationReportsPriorityOptions {
	"low" = "low",
	"normal" = "normal",
	"high" = "high",
	"urgent" = "urgent",
}
export type ModerationReportsRecord<Tevidence = unknown> = {
	assigned_to?: RecordIdString
	created: IsoAutoDateString
	details?: string
	evidence?: null | Tevidence
	id: string
	internal_notes?: string
	priority?: ModerationReportsPriorityOptions
	reason_code: ModerationReportsReasonCodeOptions
	reporter_id: RecordIdString
	status: ModerationReportsStatusOptions
	target_id: string
	target_type: ModerationReportsTargetTypeOptions
	updated: IsoAutoDateString
}

export enum NotificationDigestDeliveriesChannelOptions {
	"email" = "email",
	"push" = "push",
}

export enum NotificationDigestDeliveriesFrequencyOptions {
	"daily" = "daily",
	"weekly" = "weekly",
}

export enum NotificationDigestDeliveriesStatusOptions {
	"pending" = "pending",
	"sent" = "sent",
	"failed" = "failed",
	"empty" = "empty",
}
export type NotificationDigestDeliveriesRecord = {
	attempts?: number
	channel: NotificationDigestDeliveriesChannelOptions
	created: IsoAutoDateString
	delivery_key: string
	frequency: NotificationDigestDeliveriesFrequencyOptions
	id: string
	last_error?: string
	next_attempt_at?: IsoDateString
	notification_ids?: RecordIdString[]
	period: string
	sent_at?: IsoDateString
	status: NotificationDigestDeliveriesStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export enum NotificationsTypeOptions {
	"new_group_post_comment" = "new_group_post_comment",
	"new_group_post" = "new_group_post",
	"new_group_membership_request" = "new_group_membership_request",
	"new_event" = "new_event",
	"group_membership_accept" = "group_membership_accept",
	"group_membership_admin_approve" = "group_membership_admin_approve",
	"group_membership_invitation" = "group_membership_invitation",
	"group_membership_decline" = "group_membership_decline",
	"event_membership_join" = "event_membership_join",
	"event_membership_leave" = "event_membership_leave",
	"event_membership_invitation" = "event_membership_invitation",
	"event_content_report" = "event_content_report",
	"event_waitlist_promotion" = "event_waitlist_promotion",
	"event_invitation" = "event_invitation",
	"event_join_request" = "event_join_request",
	"event_join_approved" = "event_join_approved",
	"event_join_declined" = "event_join_declined",
	"event_auto_cancelled" = "event_auto_cancelled",
	"venue_application_approved" = "venue_application_approved",
	"venue_application_rejected" = "venue_application_rejected",
	"venue_verification_revoked" = "venue_verification_revoked",
	"venue_verification_restored" = "venue_verification_restored",
	"platform_content_restricted" = "platform_content_restricted",
	"platform_content_restored" = "platform_content_restored",
	"platform_staff_role_changed" = "platform_staff_role_changed",
	"platform_account_suspended" = "platform_account_suspended",
	"platform_account_restored" = "platform_account_restored",
	"platform_email_changed" = "platform_email_changed",
	"platform_password_reset_requested" = "platform_password_reset_requested",
	"event_deleted" = "event_deleted",
	"business_new_event" = "business_new_event",
	"business_new_session" = "business_new_session",
	"business_availability" = "business_availability",
	"event_reminder" = "event_reminder",
	"event_changed" = "event_changed",
	"circle_invitation" = "circle_invitation",
	"circle_membership" = "circle_membership",
	"event_plan_invitation" = "event_plan_invitation",
	"event_plan_selected" = "event_plan_selected",
	"departure_reminder" = "departure_reminder",
	"departure_reminder_changed" = "departure_reminder_changed",
	"event_waitlist_offer" = "event_waitlist_offer",
	"event_waitlist_offer_expired" = "event_waitlist_offer_expired",
	"notification_digest" = "notification_digest",
	"customer_refund_completed" = "customer_refund_completed",
	"resource_booking_rescheduled" = "resource_booking_rescheduled",
	"business_new_post" = "business_new_post",
	"business_community_message" = "business_community_message",
	"business_conversation_retention_warning" = "business_conversation_retention_warning",
	"event_organizer_invitation" = "event_organizer_invitation",
	"event_organizer_accepted" = "event_organizer_accepted",
	"event_organizer_declined" = "event_organizer_declined",
	"event_organizer_capabilities_changed" = "event_organizer_capabilities_changed",
	"event_organizer_removed" = "event_organizer_removed",
	"event_organizer_resigned" = "event_organizer_resigned",
	"event_organizer_revoked" = "event_organizer_revoked",
	"event_ownership_transferred" = "event_ownership_transferred",
}
export type NotificationsRecord = {
	actor_id?: RecordIdString
	created: IsoAutoDateString
	event_id?: RecordIdString
	event_post_id?: RecordIdString
	group_id?: RecordIdString
	group_post_comment_id?: RecordIdString
	group_post_id?: RecordIdString
	id: string
	is_read?: boolean
	message: string
	seen_at?: IsoDateString
	title: string
	type: NotificationsTypeOptions
	updated: IsoAutoDateString
	url?: string
	user_id: RecordIdString
}

export enum NotificationsViewTypeOptions {
	"new_group_post_comment" = "new_group_post_comment",
	"new_group_post" = "new_group_post",
	"new_group_membership_request" = "new_group_membership_request",
	"new_event" = "new_event",
	"group_membership_accept" = "group_membership_accept",
	"group_membership_admin_approve" = "group_membership_admin_approve",
	"group_membership_invitation" = "group_membership_invitation",
	"group_membership_decline" = "group_membership_decline",
	"event_membership_join" = "event_membership_join",
	"event_membership_leave" = "event_membership_leave",
	"event_membership_invitation" = "event_membership_invitation",
	"event_content_report" = "event_content_report",
	"event_waitlist_promotion" = "event_waitlist_promotion",
	"event_invitation" = "event_invitation",
	"event_join_request" = "event_join_request",
	"event_join_approved" = "event_join_approved",
	"event_join_declined" = "event_join_declined",
	"event_auto_cancelled" = "event_auto_cancelled",
	"venue_application_approved" = "venue_application_approved",
	"venue_application_rejected" = "venue_application_rejected",
	"venue_verification_revoked" = "venue_verification_revoked",
	"venue_verification_restored" = "venue_verification_restored",
	"platform_content_restricted" = "platform_content_restricted",
	"platform_content_restored" = "platform_content_restored",
	"platform_staff_role_changed" = "platform_staff_role_changed",
	"platform_account_suspended" = "platform_account_suspended",
	"platform_account_restored" = "platform_account_restored",
	"platform_email_changed" = "platform_email_changed",
	"platform_password_reset_requested" = "platform_password_reset_requested",
	"event_deleted" = "event_deleted",
	"business_new_event" = "business_new_event",
	"business_new_session" = "business_new_session",
	"business_availability" = "business_availability",
	"event_reminder" = "event_reminder",
	"event_changed" = "event_changed",
	"circle_invitation" = "circle_invitation",
	"circle_membership" = "circle_membership",
	"event_plan_invitation" = "event_plan_invitation",
	"event_plan_selected" = "event_plan_selected",
	"departure_reminder" = "departure_reminder",
	"departure_reminder_changed" = "departure_reminder_changed",
	"event_waitlist_offer" = "event_waitlist_offer",
	"event_waitlist_offer_expired" = "event_waitlist_offer_expired",
	"notification_digest" = "notification_digest",
	"customer_refund_completed" = "customer_refund_completed",
	"resource_booking_rescheduled" = "resource_booking_rescheduled",
	"business_new_post" = "business_new_post",
	"business_community_message" = "business_community_message",
	"business_conversation_retention_warning" = "business_conversation_retention_warning",
	"event_organizer_invitation" = "event_organizer_invitation",
	"event_organizer_accepted" = "event_organizer_accepted",
	"event_organizer_declined" = "event_organizer_declined",
	"event_organizer_capabilities_changed" = "event_organizer_capabilities_changed",
	"event_organizer_removed" = "event_organizer_removed",
	"event_organizer_resigned" = "event_organizer_resigned",
	"event_organizer_revoked" = "event_organizer_revoked",
	"event_ownership_transferred" = "event_ownership_transferred",
}
export type NotificationsViewRecord = {
	actor_avatar?: FileNameString
	actor_id?: RecordIdString
	created: IsoAutoDateString
	group_id?: RecordIdString
	id: string
	is_read?: boolean
	message: string
	seen_at?: IsoDateString
	title: string
	type: NotificationsViewTypeOptions
	updated: IsoAutoDateString
	url?: string
	user_id: RecordIdString
}

export enum PeopleCircleMembersStatusOptions {
	"invited" = "invited",
	"accepted" = "accepted",
}
export type PeopleCircleMembersRecord = {
	circle_id: RecordIdString
	created: IsoAutoDateString
	id: string
	invited_by_id: RecordIdString
	notify_circle?: boolean
	share_availability?: boolean
	share_plans?: boolean
	status: PeopleCircleMembersStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export type PeopleCirclesRecord = {
	created: IsoAutoDateString
	id: string
	members_can_invite?: boolean
	name: string
	owner_id: RecordIdString
	updated: IsoAutoDateString
}

export type PeopleListMembersRecord = {
	created: IsoAutoDateString
	id: string
	list_id: RecordIdString
	saved_person_id: RecordIdString
	updated: IsoAutoDateString
}

export type PeopleListsRecord = {
	created: IsoAutoDateString
	id: string
	name: string
	owner_id: RecordIdString
	updated: IsoAutoDateString
}

export enum PhoneVerificationAttemptsStatusOptions {
	"pending" = "pending",
	"approved" = "approved",
	"failed" = "failed",
	"expired" = "expired",
}
export type PhoneVerificationAttemptsRecord = {
	check_count?: number
	created: IsoAutoDateString
	expires_at: IsoDateString
	id: string
	phone_e164: string
	provider_sid: string
	status: PhoneVerificationAttemptsStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export type PlanMatchRateLimitsRecord = {
	id: string
	request_count: number
	user_id: RecordIdString
	window_start: IsoDateString
}

export type PlatformAdminActionsRecord<Tafter_state = unknown, Tbefore_state = unknown> = {
	action: string
	actor_id: RecordIdString
	after_state?: null | Tafter_state
	before_state?: null | Tbefore_state
	created: IsoAutoDateString
	id: string
	reason: string
	target_id: string
	target_type: string
}

export type PlatformSettingsRecord<Tsecret_metadata = unknown, Tsecret_values = unknown, Tvalues = unknown> = {
	created: IsoAutoDateString
	id: string
	revision: number
	secret_metadata?: null | Tsecret_metadata
	secret_values?: null | Tsecret_values
	updated: IsoAutoDateString
	updated_by?: RecordIdString
	values?: null | Tvalues
}

export type PostEventContinuityStateRecord<Tcompleted_actions = unknown> = {
	completed_actions?: null | Tcompleted_actions
	created: IsoAutoDateString
	dismissed?: boolean
	event_id: RecordIdString
	id: string
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export enum PrivacyActionAuditActionOptions {
	"export" = "export",
	"sessions_revoked" = "sessions_revoked",
	"deletion_scheduled" = "deletion_scheduled",
	"deletion_cancelled" = "deletion_cancelled",
	"account_deleted" = "account_deleted",
}
export type PrivacyActionAuditRecord = {
	action: PrivacyActionAuditActionOptions
	created: IsoAutoDateString
	id: string
	user_hash: string
}

export type ProfileBlocksRecord = {
	blocked_id: RecordIdString
	blocker_id: RecordIdString
	created: IsoAutoDateString
	id: string
}

export type PushSubscriptionsRecord<Tkeys = unknown> = {
	created: IsoAutoDateString
	endpoint: string
	id: string
	keys: null | Tkeys
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export type RecentPeopleRecord = {
	created: IsoAutoDateString
	id: string
	owner_id: RecordIdString
	person_id: RecordIdString
	updated: IsoAutoDateString
}

export type ResourceAvailabilityRulesRecord = {
	active?: boolean
	created: IsoAutoDateString
	end_local: string
	id: string
	resource_id: RecordIdString
	start_local: string
	valid_from?: IsoDateString
	valid_until?: IsoDateString
	weekday: number
}

export type ResourceBlackoutsRecord = {
	created: IsoAutoDateString
	ends_at: IsoDateString
	id: string
	reason?: string
	resource_id: RecordIdString
	starts_at: IsoDateString
}

export type ResourceBookingAuditRecord<Tdetails = unknown> = {
	action: string
	actor_id?: RecordIdString
	booking_id: RecordIdString
	created: IsoAutoDateString
	details?: null | Tdetails
	id: string
	operation_key: string
}

export enum ResourceBookingsStatusOptions {
	"hold" = "hold",
	"pending_payment" = "pending_payment",
	"confirmed" = "confirmed",
	"cancelled" = "cancelled",
	"expired" = "expired",
	"refund_pending" = "refund_pending",
	"refunded" = "refunded",
}
export type ResourceBookingsRecord = {
	amount_minor?: number
	cancellation_reason?: string
	cancelled_at?: IsoDateString
	created: IsoAutoDateString
	created_by_id: RecordIdString
	currency?: string
	ends_at: IsoDateString
	expires_at?: IsoDateString
	id: string
	idempotency_key: string
	operational_note?: string
	operations_version: number
	payment_reference?: string
	quantity: number
	resource_id: RecordIdString
	starts_at: IsoDateString
	status: ResourceBookingsStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export enum ResourceMaintenanceStateOptions {
	"active" = "active",
	"cancelled" = "cancelled",
}
export type ResourceMaintenanceRecord = {
	blackout_id?: RecordIdString
	cancelled_at?: IsoDateString
	created: IsoAutoDateString
	created_by_id: RecordIdString
	ends_at: IsoDateString
	id: string
	operational_note?: string
	resource_id: RecordIdString
	retain_until?: IsoDateString
	starts_at: IsoDateString
	state: ResourceMaintenanceStateOptions
	summary: string
	updated: IsoAutoDateString
	updated_by_id: RecordIdString
	version: number
}

export enum ResourceOperationNotificationDeliveriesStatusOptions {
	"pending" = "pending",
	"sent" = "sent",
}
export type ResourceOperationNotificationDeliveriesRecord = {
	attempts: number
	audit_id: RecordIdString
	booking_id: RecordIdString
	business_id: RecordIdString
	created: IsoAutoDateString
	id: string
	last_error?: string
	retry_at?: IsoDateString
	status: ResourceOperationNotificationDeliveriesStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export enum ResourceOperationsAuditSourceTypeOptions {
	"booking" = "booking",
	"maintenance" = "maintenance",
	"assignment" = "assignment",
}

export enum ResourceOperationsAuditNotificationOutcomeOptions {
	"not_applicable" = "not_applicable",
	"queued" = "queued",
}
export type ResourceOperationsAuditRecord<Tafter = unknown, Tbefore = unknown, Tresult = unknown> = {
	action: string
	actor_id: RecordIdString
	after?: null | Tafter
	before?: null | Tbefore
	business_id: RecordIdString
	created: IsoAutoDateString
	id: string
	idempotency_key: string
	notification_outcome: ResourceOperationsAuditNotificationOutcomeOptions
	result?: null | Tresult
	retain_until: IsoDateString
	source_id: string
	source_type: ResourceOperationsAuditSourceTypeOptions
}

export enum ResourceStaffAssignmentsTargetTypeOptions {
	"booking" = "booking",
	"maintenance" = "maintenance",
}

export enum ResourceStaffAssignmentsStateOptions {
	"active" = "active",
	"detached" = "detached",
}
export type ResourceStaffAssignmentsRecord = {
	booking_id?: RecordIdString
	business_id: RecordIdString
	created: IsoAutoDateString
	created_by_id: RecordIdString
	detached_at?: IsoDateString
	id: string
	maintenance_id?: RecordIdString
	retain_until?: IsoDateString
	role: string
	staff_id: RecordIdString
	state: ResourceStaffAssignmentsStateOptions
	target_type: ResourceStaffAssignmentsTargetTypeOptions
	updated: IsoAutoDateString
	updated_by_id: RecordIdString
	version: number
}

export type SavedFeedsRecord<Tfilter_json = unknown> = {
	created: IsoAutoDateString
	filter_json: null | Tfilter_json
	id: string
	last_viewed?: IsoDateString
	name: string
	pinned?: boolean
	sort_order?: number
	updated: IsoAutoDateString
	user: RecordIdString
}

export type SavedPeopleRecord = {
	created: IsoAutoDateString
	id: string
	owner_id: RecordIdString
	person_id: RecordIdString
	updated: IsoAutoDateString
}

export enum SeedRunResourcesStatusOptions {
	"active" = "active",
	"deleted" = "deleted",
}
export type SeedRunResourcesRecord = {
	collection_name: string
	created: IsoAutoDateString
	created_order: number
	deleted_at?: IsoDateString
	id: string
	label: string
	record_id: string
	run_id: RecordIdString
	status: SeedRunResourcesStatusOptions
}

export enum SeedRunsStatusOptions {
	"creating" = "creating",
	"ready" = "ready",
	"failed" = "failed",
	"deleting" = "deleting",
	"deleted" = "deleted",
	"cleanup_failed" = "cleanup_failed",
}
export type SeedRunsRecord<Tconfig = unknown, Tscenarios = unknown, Tsummary = unknown> = {
	config: null | Tconfig
	created: IsoAutoDateString
	created_by_id: RecordIdString
	deleted_at?: IsoDateString
	error?: string
	id: string
	name: string
	scenarios: null | Tscenarios
	status: SeedRunsStatusOptions
	summary: null | Tsummary
	updated: IsoAutoDateString
}

export type TimezonesRecord = {
	created: IsoAutoDateString
	id: string
	label: string
	name: string
	tz_code: string
	updated: IsoAutoDateString
	utc: string
}

export enum TravelRemindersModeOptions {
	"walking" = "walking",
	"cycling" = "cycling",
	"transit" = "transit",
	"driving" = "driving",
}

export enum TravelRemindersProviderOptions {
	"coarse_fallback" = "coarse_fallback",
	"mapbox_directions" = "mapbox_directions",
	"google_directions" = "google_directions",
}
export type TravelRemindersRecord = {
	active?: boolean
	buffer_minutes: number
	created: IsoAutoDateString
	departure_at: IsoDateString
	estimated_minutes: number
	event_id: RecordIdString
	event_starts_at: IsoDateString
	id: string
	mode: TravelRemindersModeOptions
	provider: TravelRemindersProviderOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export enum UserAvailabilityKindOptions {
	"once" = "once",
	"weekly" = "weekly",
}

export enum UserAvailabilitySharingOptions {
	"private" = "private",
	"matching_only" = "matching_only",
}
export type UserAvailabilityRecord<Texceptions = unknown> = {
	created: IsoAutoDateString
	effective_from?: IsoDateString
	effective_until?: IsoDateString
	ends_at?: IsoDateString
	exceptions?: null | Texceptions
	id: string
	kind: UserAvailabilityKindOptions
	label?: string
	local_end?: string
	local_start?: string
	paused?: boolean
	sharing: UserAvailabilitySharingOptions
	starts_at?: IsoDateString
	timezone: string
	updated: IsoAutoDateString
	user_id: RecordIdString
	weekday?: number
}

export type UserPresenceRecord = {
	client_id: string
	created: IsoAutoDateString
	id: string
	updated: IsoAutoDateString
	user_id: RecordIdString
}

export enum UsersModerationRoleOptions {
	"member" = "member",
	"moderator" = "moderator",
	"admin" = "admin",
}

export enum UsersModerationStateOptions {
	"active" = "active",
	"warned" = "warned",
	"suspended" = "suspended",
}

export enum UsersBusinessPlanOptions {
	"free" = "free",
	"pro" = "pro",
}

export enum UsersLocaleOptions {
	"en" = "en",
	"nb" = "nb",
}
export type UsersRecord<Tnotification_preferences = unknown, Tonboarding = unknown, Tprofile_privacy = unknown, Tvenue_photo_alt_text = unknown> = {
	allow_mutual_availability_matching?: boolean
	avatar?: FileNameString
	bio?: string
	business_category?: RecordIdString
	business_chat_enabled?: boolean
	business_directory_visible?: boolean
	business_plan: UsersBusinessPlanOptions
	connection_count?: number
	contact_discovery_enabled?: boolean
	created: IsoAutoDateString
	deletion_requested_at?: IsoDateString
	deletion_scheduled_at?: IsoDateString
	email: string
	emailVisibility?: boolean
	id: string
	is_business?: boolean
	is_venue?: boolean
	is_verified?: boolean
	last_active?: IsoDateString
	locale?: UsersLocaleOptions
	moderation_role?: UsersModerationRoleOptions
	moderation_state?: UsersModerationStateOptions
	name: string
	notification_preferences?: null | Tnotification_preferences
	onboarding?: null | Tonboarding
	onboarding_completed_at?: IsoDateString
	password: string
	phone_e164?: string
	phone_verified_at?: IsoDateString
	privacy_exported_at?: IsoDateString
	profile_privacy?: null | Tprofile_privacy
	tokenKey: string
	updated: IsoAutoDateString
	username?: string
	venue_accessibility?: string
	venue_address?: string
	venue_hours?: string
	venue_location?: GeoPoint
	venue_phone?: string
	venue_photo_alt_text?: null | Tvenue_photo_alt_text
	venue_photos?: FileNameString[]
	venue_website?: string
	verified?: boolean
}

export type UsersViewRecord<Tprofile_privacy = unknown> = {
	avatar?: FileNameString
	bio?: string
	business_category?: RecordIdString
	business_category_icon: string
	business_category_name: string
	created: IsoAutoDateString
	event_membership_count?: number
	event_post_count?: number
	group_comment_count?: number
	group_membership_count?: number
	group_post_count?: number
	hosted_event_count?: number
	id: string
	is_business?: boolean
	is_venue?: boolean
	is_verified?: boolean
	name: string
	profile_privacy?: null | Tprofile_privacy
	username?: string
	venue_accessibility?: string
	venue_address?: string
	venue_hours?: string
	venue_location?: GeoPoint
	venue_phone?: string
	venue_photos?: FileNameString[]
	venue_website?: string
}

export enum VenueApplicationsStatusOptions {
	"pending" = "pending",
	"approved" = "approved",
	"rejected" = "rejected",
}
export type VenueApplicationsRecord = {
	address: string
	business_category: RecordIdString
	business_name: string
	created: IsoAutoDateString
	hours: string
	id: string
	location: GeoPoint
	phone?: string
	proof: FileNameString[]
	reviewer_notes?: string
	status: VenueApplicationsStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
	website?: string
}

export type VenueAuditLogRecord<Tdetails = unknown> = {
	action: string
	actor_id: RecordIdString
	created: IsoAutoDateString
	details?: null | Tdetails
	id: string
	target_user_id?: RecordIdString
	venue_id: RecordIdString
}

export type VenueEventInsightsRecord<Tattending_count = unknown, Tmaybe_count = unknown, Tresponse_count = unknown> = {
	attending_count?: null | Tattending_count
	event_id?: RecordIdString
	id: string
	maybe_count?: null | Tmaybe_count
	response_count?: null | Tresponse_count
	starts_at: IsoDateString
	title: string
	tz_code: string
	venue_id: RecordIdString
}

export enum VenueStaffRoleOptions {
	"owner" = "owner",
	"manager" = "manager",
	"editor" = "editor",
}

export enum VenueStaffStatusOptions {
	"invited" = "invited",
	"accepted" = "accepted",
	"declined" = "declined",
}
export type VenueStaffRecord = {
	created: IsoAutoDateString
	id: string
	invited_by_id: RecordIdString
	role: VenueStaffRoleOptions
	status: VenueStaffStatusOptions
	updated: IsoAutoDateString
	user_id: RecordIdString
	venue_id: RecordIdString
}

export type VippsFinancialAuditRecord<Tdetails = unknown> = {
	action: string
	amount_minor?: number
	attempt_id: RecordIdString
	created: IsoAutoDateString
	details?: null | Tdetails
	id: string
	provider_event_id: string
}

export enum VippsPaymentAttemptsStatusOptions {
	"pending" = "pending",
	"authorized" = "authorized",
	"paid" = "paid",
	"failed" = "failed",
	"cancelled" = "cancelled",
	"expired" = "expired",
	"refund_pending" = "refund_pending",
	"partially_refunded" = "partially_refunded",
	"refunded" = "refunded",
}
export type VippsPaymentAttemptsRecord = {
	amount_minor: number
	cancel_attendance_on_refund?: boolean
	created: IsoAutoDateString
	currency: string
	event_id: RecordIdString
	expires_at: IsoDateString
	fulfilled_at?: IsoDateString
	id: string
	idempotency_key: string
	membership_id?: RecordIdString
	redirect_url?: string
	reference: string
	refund_pending_amount_minor?: number
	refunded_amount_minor?: number
	status: VippsPaymentAttemptsStatusOptions
	transfer_id?: RecordIdString
	updated: IsoAutoDateString
	user_id: RecordIdString
}

// Response types include system fields and match responses from the PocketBase API
export type AuthoriginsResponse<Texpand = unknown> = Required<AuthoriginsRecord> & BaseSystemFields<Texpand>
export type ExternalauthsResponse<Texpand = unknown> = Required<ExternalauthsRecord> & BaseSystemFields<Texpand>
export type MfasResponse<Texpand = unknown> = Required<MfasRecord> & BaseSystemFields<Texpand>
export type OtpsResponse<Texpand = unknown> = Required<OtpsRecord> & BaseSystemFields<Texpand>
export type SuperusersResponse<Texpand = unknown> = Required<SuperusersRecord> & AuthSystemFields<Texpand>
export type AdminImpersonationSessionsResponse<Texpand = unknown> = Required<AdminImpersonationSessionsRecord> & BaseSystemFields<Texpand>
export type BusinessCommunityRateLimitsResponse<Texpand = unknown> = Required<BusinessCommunityRateLimitsRecord> & BaseSystemFields<Texpand>
export type BusinessCommunitySafetyResponse<Texpand = unknown> = Required<BusinessCommunitySafetyRecord> & BaseSystemFields<Texpand>
export type BusinessConversationsResponse<Texpand = unknown> = Required<BusinessConversationsRecord> & BaseSystemFields<Texpand>
export type BusinessEmbedConfigsResponse<Tallowed_origins = unknown, Tsections = unknown, Texpand = unknown> = Required<BusinessEmbedConfigsRecord<Tallowed_origins, Tsections>> & BaseSystemFields<Texpand>
export type BusinessEmbedRateLimitsResponse<Texpand = unknown> = Required<BusinessEmbedRateLimitsRecord> & BaseSystemFields<Texpand>
export type BusinessEmbedReferralDailyResponse<Texpand = unknown> = Required<BusinessEmbedReferralDailyRecord> & BaseSystemFields<Texpand>
export type BusinessEntitlementsResponse<Texpand = unknown> = Required<BusinessEntitlementsRecord> & BaseSystemFields<Texpand>
export type BusinessFeatureFlagsResponse<Texpand = unknown> = Required<BusinessFeatureFlagsRecord> & BaseSystemFields<Texpand>
export type BusinessFinanceAccessResponse<Texpand = unknown> = Required<BusinessFinanceAccessRecord> & BaseSystemFields<Texpand>
export type BusinessFinanceAuditResponse<Tdetails = unknown, Texpand = unknown> = Required<BusinessFinanceAuditRecord<Tdetails>> & BaseSystemFields<Texpand>
export type BusinessFinanceLedgerResponse<Tsnapshot = unknown, Texpand = unknown> = Required<BusinessFinanceLedgerRecord<Tsnapshot>> & BaseSystemFields<Texpand>
export type BusinessFollowsResponse<Texpand = unknown> = Required<BusinessFollowsRecord> & BaseSystemFields<Texpand>
export type BusinessMessagesResponse<Texpand = unknown> = Required<BusinessMessagesRecord> & BaseSystemFields<Texpand>
export type BusinessPilotAuditResponse<Tafter_state = unknown, Tbefore_state = unknown, Texpand = unknown> = Required<BusinessPilotAuditRecord<Tafter_state, Tbefore_state>> & BaseSystemFields<Texpand>
export type BusinessPilotProgramsResponse<Tthresholds = unknown, Texpand = unknown> = Required<BusinessPilotProgramsRecord<Tthresholds>> & BaseSystemFields<Texpand>
export type BusinessPilotRosterResponse<Texpand = unknown> = Required<BusinessPilotRosterRecord> & BaseSystemFields<Texpand>
export type BusinessPlansResponse<Tentitlements = unknown, Tname = unknown, Texpand = unknown> = Required<BusinessPlansRecord<Tentitlements, Tname>> & BaseSystemFields<Texpand>
export type BusinessPostCommentsResponse<Texpand = unknown> = Required<BusinessPostCommentsRecord> & BaseSystemFields<Texpand>
export type BusinessPostsResponse<Texpand = unknown> = Required<BusinessPostsRecord> & BaseSystemFields<Texpand>
export type BusinessReconciliationExceptionsResponse<Tdetails = unknown, Texpand = unknown> = Required<BusinessReconciliationExceptionsRecord<Tdetails>> & BaseSystemFields<Texpand>
export type BusinessResourcesResponse<Texpand = unknown> = Required<BusinessResourcesRecord> & BaseSystemFields<Texpand>
export type BusinessSettlementsResponse<Tprovider_snapshot = unknown, Texpand = unknown> = Required<BusinessSettlementsRecord<Tprovider_snapshot>> & BaseSystemFields<Texpand>
export type BusinessSubscriptionEventsResponse<Tdetails = unknown, Texpand = unknown> = Required<BusinessSubscriptionEventsRecord<Tdetails>> & BaseSystemFields<Texpand>
export type BusinessSubscriptionInvoicesResponse<Tsnapshot = unknown, Texpand = unknown> = Required<BusinessSubscriptionInvoicesRecord<Tsnapshot>> & BaseSystemFields<Texpand>
export type BusinessSubscriptionsResponse<Texpand = unknown> = Required<BusinessSubscriptionsRecord> & BaseSystemFields<Texpand>
export type BusinessSupportCasesResponse<Tdiagnostic_context = unknown, Texpand = unknown> = Required<BusinessSupportCasesRecord<Tdiagnostic_context>> & BaseSystemFields<Texpand>
export type ClientDiagnosticRateBucketsResponse<Texpand = unknown> = Required<ClientDiagnosticRateBucketsRecord> & BaseSystemFields<Texpand>
export type ClientDiagnosticsResponse<Texpand = unknown> = Required<ClientDiagnosticsRecord> & BaseSystemFields<Texpand>
export type ContactDiscoveryRequestsResponse<Texpand = unknown> = Required<ContactDiscoveryRequestsRecord> & BaseSystemFields<Texpand>
export type CountriesResponse<Texpand = unknown> = Required<CountriesRecord> & BaseSystemFields<Texpand>
export type CustomerReceiptsResponse<Tsnapshot = unknown, Texpand = unknown> = Required<CustomerReceiptsRecord<Tsnapshot>> & BaseSystemFields<Texpand>
export type EphemeralRsvpsResponse<Texpand = unknown> = Required<EphemeralRsvpsRecord> & BaseSystemFields<Texpand>
export type EventAgeProfilesResponse<Texpand = unknown> = Required<EventAgeProfilesRecord> & BaseSystemFields<Texpand>
export type EventAnticipationOptionsResponse<Texpand = unknown> = Required<EventAnticipationOptionsRecord> & BaseSystemFields<Texpand>
export type EventAnticipationPromptsResponse<Texpand = unknown> = Required<EventAnticipationPromptsRecord> & BaseSystemFields<Texpand>
export type EventAnticipationResponsesResponse<Texpand = unknown> = Required<EventAnticipationResponsesRecord> & BaseSystemFields<Texpand>
export type EventAnticipationStateResponse<Texpand = unknown> = Required<EventAnticipationStateRecord> & BaseSystemFields<Texpand>
export type EventBookmarksResponse<Texpand = unknown> = Required<EventBookmarksRecord> & BaseSystemFields<Texpand>
export type EventChatsResponse<Texpand = unknown> = Required<EventChatsRecord> & BaseSystemFields<Texpand>
export type EventChatsViewResponse<Texpand = unknown> = Required<EventChatsViewRecord> & BaseSystemFields<Texpand>
export type EventCheckInAuditResponse<Texpand = unknown> = Required<EventCheckInAuditRecord> & BaseSystemFields<Texpand>
export type EventCompanyBlocksResponse<Texpand = unknown> = Required<EventCompanyBlocksRecord> & BaseSystemFields<Texpand>
export type EventCompanyMatchesResponse<Texpand = unknown> = Required<EventCompanyMatchesRecord> & BaseSystemFields<Texpand>
export type EventCompanyMessagesResponse<Texpand = unknown> = Required<EventCompanyMessagesRecord> & BaseSystemFields<Texpand>
export type EventCompanyOptInsResponse<Texpand = unknown> = Required<EventCompanyOptInsRecord> & BaseSystemFields<Texpand>
export type EventCompanyRateLimitsResponse<Texpand = unknown> = Required<EventCompanyRateLimitsRecord> & BaseSystemFields<Texpand>
export type EventCompanyReactionsResponse<Texpand = unknown> = Required<EventCompanyReactionsRecord> & BaseSystemFields<Texpand>
export type EventCompanyReportsResponse<Texpand = unknown> = Required<EventCompanyReportsRecord> & BaseSystemFields<Texpand>
export type EventCompanyRoomMembersResponse<Texpand = unknown> = Required<EventCompanyRoomMembersRecord> & BaseSystemFields<Texpand>
export type EventCompanyRoomSignalsResponse<Texpand = unknown> = Required<EventCompanyRoomSignalsRecord> & BaseSystemFields<Texpand>
export type EventCompanyRoomsResponse<Texpand = unknown> = Required<EventCompanyRoomsRecord> & BaseSystemFields<Texpand>
export type EventContentReportsResponse<Texpand = unknown> = Required<EventContentReportsRecord> & BaseSystemFields<Texpand>
export type EventFeedbackResponse<Texpand = unknown> = Required<EventFeedbackRecord> & BaseSystemFields<Texpand>
export type EventImpressionsResponse<Texpand = unknown> = Required<EventImpressionsRecord> & BaseSystemFields<Texpand>
export type EventMembersResponse<Texpand = unknown> = Required<EventMembersRecord> & BaseSystemFields<Texpand>
export type EventMemoriesResponse<Texpand = unknown> = Required<EventMemoriesRecord> & BaseSystemFields<Texpand>
export type EventNotificationDeliveriesResponse<Texpand = unknown> = Required<EventNotificationDeliveriesRecord> & BaseSystemFields<Texpand>
export type EventOrganizerAuditResponse<Tafter = unknown, Tbefore = unknown, Texpand = unknown> = Required<EventOrganizerAuditRecord<Tafter, Tbefore>> & BaseSystemFields<Texpand>
export type EventOrganizersResponse<Texpand = unknown> = Required<EventOrganizersRecord> & BaseSystemFields<Texpand>
export type EventPlanOptionsResponse<Texpand = unknown> = Required<EventPlanOptionsRecord> & BaseSystemFields<Texpand>
export type EventPlanParticipantsResponse<Texpand = unknown> = Required<EventPlanParticipantsRecord> & BaseSystemFields<Texpand>
export type EventPlanVotesResponse<Texpand = unknown> = Required<EventPlanVotesRecord> & BaseSystemFields<Texpand>
export type EventPlansResponse<Tsearch_preferences = unknown, Texpand = unknown> = Required<EventPlansRecord<Tsearch_preferences>> & BaseSystemFields<Texpand>
export type EventPostCommentsResponse<Texpand = unknown> = Required<EventPostCommentsRecord> & BaseSystemFields<Texpand>
export type EventPostCommentsViewResponse<Texpand = unknown> = Required<EventPostCommentsViewRecord> & BaseSystemFields<Texpand>
export type EventPostsResponse<Texpand = unknown> = Required<EventPostsRecord> & BaseSystemFields<Texpand>
export type EventPostsViewResponse<Texpand = unknown> = Required<EventPostsViewRecord> & BaseSystemFields<Texpand>
export type EventRefundRequestsResponse<Texpand = unknown> = Required<EventRefundRequestsRecord> & BaseSystemFields<Texpand>
export type EventSeriesResponse<Tadded_dates = unknown, Texcluded_dates = unknown, Tweekdays = unknown, Texpand = unknown> = Required<EventSeriesRecord<Tadded_dates, Texcluded_dates, Tweekdays>> & BaseSystemFields<Texpand>
export type EventTicketChallengesResponse<Texpand = unknown> = Required<EventTicketChallengesRecord> & BaseSystemFields<Texpand>
export type EventTicketTransfersResponse<Texpand = unknown> = Required<EventTicketTransfersRecord> & BaseSystemFields<Texpand>
export type EventTicketsResponse<Texpand = unknown> = Required<EventTicketsRecord> & BaseSystemFields<Texpand>
export type EventViewResponse<Tattending_avatars_sample = unknown, Tattending_count = unknown, Tgeojson = unknown, Texpand = unknown> = Required<EventViewRecord<Tattending_avatars_sample, Tattending_count, Tgeojson>> & BaseSystemFields<Texpand>
export type EventsResponse<Tgeojson = unknown, Tnotification_settings = unknown, Texpand = unknown> = Required<EventsRecord<Tgeojson, Tnotification_settings>> & BaseSystemFields<Texpand>
export type EventsViewResponse<Tattending_avatars_sample = unknown, Tattending_count = unknown, Tphoto = unknown, Texpand = unknown> = Required<EventsViewRecord<Tattending_avatars_sample, Tattending_count, Tphoto>> & BaseSystemFields<Texpand>
export type FeatureFlagsResponse<Texpand = unknown> = Required<FeatureFlagsRecord> & BaseSystemFields<Texpand>
export type GroupCategoriesResponse<Texpand = unknown> = Required<GroupCategoriesRecord> & BaseSystemFields<Texpand>
export type GroupInviteLinksResponse<Texpand = unknown> = Required<GroupInviteLinksRecord> & BaseSystemFields<Texpand>
export type GroupMembersResponse<Texpand = unknown> = Required<GroupMembersRecord> & BaseSystemFields<Texpand>
export type GroupMembersViewResponse<Texpand = unknown> = Required<GroupMembersViewRecord> & BaseSystemFields<Texpand>
export type GroupPostCommentsResponse<Texpand = unknown> = Required<GroupPostCommentsRecord> & BaseSystemFields<Texpand>
export type GroupPostCommentsViewResponse<Texpand = unknown> = Required<GroupPostCommentsViewRecord> & BaseSystemFields<Texpand>
export type GroupPostsResponse<Texpand = unknown> = Required<GroupPostsRecord> & BaseSystemFields<Texpand>
export type GroupPostsViewResponse<Texpand = unknown> = Required<GroupPostsViewRecord> & BaseSystemFields<Texpand>
export type GroupViewResponse<Tgeojson = unknown, Tmembers_avatar_sample = unknown, Texpand = unknown> = Required<GroupViewRecord<Tgeojson, Tmembers_avatar_sample>> & BaseSystemFields<Texpand>
export type GroupsResponse<Tgeojson = unknown, Texpand = unknown> = Required<GroupsRecord<Tgeojson>> & BaseSystemFields<Texpand>
export type GroupsViewResponse<Tupcoming_event_count = unknown, Texpand = unknown> = Required<GroupsViewRecord<Tupcoming_event_count>> & BaseSystemFields<Texpand>
export type HostEventAnalyticsResponse<Tfeedback_accessibility = unknown, Tfeedback_count = unknown, Tfeedback_overall = unknown, Tfeedback_return = unknown, Tfeedback_safety = unknown, Timpressions = unknown, Texpand = unknown> = Required<HostEventAnalyticsRecord<Tfeedback_accessibility, Tfeedback_count, Tfeedback_overall, Tfeedback_return, Tfeedback_safety, Timpressions>> & BaseSystemFields<Texpand>
export type HostReliabilitySignalsResponse<Taccessibility_accuracy = unknown, Tcancellation_rate = unknown, Tdescription_accuracy = unknown, Tpunctual_event_count = unknown, Tpunctuality_rate = unknown, Tverified_feedback_count = unknown, Texpand = unknown> = Required<HostReliabilitySignalsRecord<Taccessibility_accuracy, Tcancellation_rate, Tdescription_accuracy, Tpunctual_event_count, Tpunctuality_rate, Tverified_feedback_count>> & BaseSystemFields<Texpand>
export type LaunchEventsResponse<Texpand = unknown> = Required<LaunchEventsRecord> & BaseSystemFields<Texpand>
export type ModerationActionsResponse<Texpand = unknown> = Required<ModerationActionsRecord> & BaseSystemFields<Texpand>
export type ModerationAppealsResponse<Texpand = unknown> = Required<ModerationAppealsRecord> & BaseSystemFields<Texpand>
export type ModerationReportsResponse<Tevidence = unknown, Texpand = unknown> = Required<ModerationReportsRecord<Tevidence>> & BaseSystemFields<Texpand>
export type NotificationDigestDeliveriesResponse<Texpand = unknown> = Required<NotificationDigestDeliveriesRecord> & BaseSystemFields<Texpand>
export type NotificationsResponse<Texpand = unknown> = Required<NotificationsRecord> & BaseSystemFields<Texpand>
export type NotificationsViewResponse<Texpand = unknown> = Required<NotificationsViewRecord> & BaseSystemFields<Texpand>
export type PeopleCircleMembersResponse<Texpand = unknown> = Required<PeopleCircleMembersRecord> & BaseSystemFields<Texpand>
export type PeopleCirclesResponse<Texpand = unknown> = Required<PeopleCirclesRecord> & BaseSystemFields<Texpand>
export type PeopleListMembersResponse<Texpand = unknown> = Required<PeopleListMembersRecord> & BaseSystemFields<Texpand>
export type PeopleListsResponse<Texpand = unknown> = Required<PeopleListsRecord> & BaseSystemFields<Texpand>
export type PhoneVerificationAttemptsResponse<Texpand = unknown> = Required<PhoneVerificationAttemptsRecord> & BaseSystemFields<Texpand>
export type PlanMatchRateLimitsResponse<Texpand = unknown> = Required<PlanMatchRateLimitsRecord> & BaseSystemFields<Texpand>
export type PlatformAdminActionsResponse<Tafter_state = unknown, Tbefore_state = unknown, Texpand = unknown> = Required<PlatformAdminActionsRecord<Tafter_state, Tbefore_state>> & BaseSystemFields<Texpand>
export type PlatformSettingsResponse<Tsecret_metadata = unknown, Tsecret_values = unknown, Tvalues = unknown, Texpand = unknown> = Required<PlatformSettingsRecord<Tsecret_metadata, Tsecret_values, Tvalues>> & BaseSystemFields<Texpand>
export type PostEventContinuityStateResponse<Tcompleted_actions = unknown, Texpand = unknown> = Required<PostEventContinuityStateRecord<Tcompleted_actions>> & BaseSystemFields<Texpand>
export type PrivacyActionAuditResponse<Texpand = unknown> = Required<PrivacyActionAuditRecord> & BaseSystemFields<Texpand>
export type ProfileBlocksResponse<Texpand = unknown> = Required<ProfileBlocksRecord> & BaseSystemFields<Texpand>
export type PushSubscriptionsResponse<Tkeys = unknown, Texpand = unknown> = Required<PushSubscriptionsRecord<Tkeys>> & BaseSystemFields<Texpand>
export type RecentPeopleResponse<Texpand = unknown> = Required<RecentPeopleRecord> & BaseSystemFields<Texpand>
export type ResourceAvailabilityRulesResponse<Texpand = unknown> = Required<ResourceAvailabilityRulesRecord> & BaseSystemFields<Texpand>
export type ResourceBlackoutsResponse<Texpand = unknown> = Required<ResourceBlackoutsRecord> & BaseSystemFields<Texpand>
export type ResourceBookingAuditResponse<Tdetails = unknown, Texpand = unknown> = Required<ResourceBookingAuditRecord<Tdetails>> & BaseSystemFields<Texpand>
export type ResourceBookingsResponse<Texpand = unknown> = Required<ResourceBookingsRecord> & BaseSystemFields<Texpand>
export type ResourceMaintenanceResponse<Texpand = unknown> = Required<ResourceMaintenanceRecord> & BaseSystemFields<Texpand>
export type ResourceOperationNotificationDeliveriesResponse<Texpand = unknown> = Required<ResourceOperationNotificationDeliveriesRecord> & BaseSystemFields<Texpand>
export type ResourceOperationsAuditResponse<Tafter = unknown, Tbefore = unknown, Tresult = unknown, Texpand = unknown> = Required<ResourceOperationsAuditRecord<Tafter, Tbefore, Tresult>> & BaseSystemFields<Texpand>
export type ResourceStaffAssignmentsResponse<Texpand = unknown> = Required<ResourceStaffAssignmentsRecord> & BaseSystemFields<Texpand>
export type SavedFeedsResponse<Tfilter_json = unknown, Texpand = unknown> = Required<SavedFeedsRecord<Tfilter_json>> & BaseSystemFields<Texpand>
export type SavedPeopleResponse<Texpand = unknown> = Required<SavedPeopleRecord> & BaseSystemFields<Texpand>
export type SeedRunResourcesResponse<Texpand = unknown> = Required<SeedRunResourcesRecord> & BaseSystemFields<Texpand>
export type SeedRunsResponse<Tconfig = unknown, Tscenarios = unknown, Tsummary = unknown, Texpand = unknown> = Required<SeedRunsRecord<Tconfig, Tscenarios, Tsummary>> & BaseSystemFields<Texpand>
export type TimezonesResponse<Texpand = unknown> = Required<TimezonesRecord> & BaseSystemFields<Texpand>
export type TravelRemindersResponse<Texpand = unknown> = Required<TravelRemindersRecord> & BaseSystemFields<Texpand>
export type UserAvailabilityResponse<Texceptions = unknown, Texpand = unknown> = Required<UserAvailabilityRecord<Texceptions>> & BaseSystemFields<Texpand>
export type UserPresenceResponse<Texpand = unknown> = Required<UserPresenceRecord> & BaseSystemFields<Texpand>
export type UsersResponse<Tnotification_preferences = unknown, Tonboarding = unknown, Tprofile_privacy = unknown, Tvenue_photo_alt_text = unknown, Texpand = unknown> = Required<UsersRecord<Tnotification_preferences, Tonboarding, Tprofile_privacy, Tvenue_photo_alt_text>> & AuthSystemFields<Texpand>
export type UsersViewResponse<Tprofile_privacy = unknown, Texpand = unknown> = Required<UsersViewRecord<Tprofile_privacy>> & BaseSystemFields<Texpand>
export type VenueApplicationsResponse<Texpand = unknown> = Required<VenueApplicationsRecord> & BaseSystemFields<Texpand>
export type VenueAuditLogResponse<Tdetails = unknown, Texpand = unknown> = Required<VenueAuditLogRecord<Tdetails>> & BaseSystemFields<Texpand>
export type VenueEventInsightsResponse<Tattending_count = unknown, Tmaybe_count = unknown, Tresponse_count = unknown, Texpand = unknown> = Required<VenueEventInsightsRecord<Tattending_count, Tmaybe_count, Tresponse_count>> & BaseSystemFields<Texpand>
export type VenueStaffResponse<Texpand = unknown> = Required<VenueStaffRecord> & BaseSystemFields<Texpand>
export type VippsFinancialAuditResponse<Tdetails = unknown, Texpand = unknown> = Required<VippsFinancialAuditRecord<Tdetails>> & BaseSystemFields<Texpand>
export type VippsPaymentAttemptsResponse<Texpand = unknown> = Required<VippsPaymentAttemptsRecord> & BaseSystemFields<Texpand>

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
	_authOrigins: AuthoriginsRecord
	_externalAuths: ExternalauthsRecord
	_mfas: MfasRecord
	_otps: OtpsRecord
	_superusers: SuperusersRecord
	admin_impersonation_sessions: AdminImpersonationSessionsRecord
	business_community_rate_limits: BusinessCommunityRateLimitsRecord
	business_community_safety: BusinessCommunitySafetyRecord
	business_conversations: BusinessConversationsRecord
	business_embed_configs: BusinessEmbedConfigsRecord
	business_embed_rate_limits: BusinessEmbedRateLimitsRecord
	business_embed_referral_daily: BusinessEmbedReferralDailyRecord
	business_entitlements: BusinessEntitlementsRecord
	business_feature_flags: BusinessFeatureFlagsRecord
	business_finance_access: BusinessFinanceAccessRecord
	business_finance_audit: BusinessFinanceAuditRecord
	business_finance_ledger: BusinessFinanceLedgerRecord
	business_follows: BusinessFollowsRecord
	business_messages: BusinessMessagesRecord
	business_pilot_audit: BusinessPilotAuditRecord
	business_pilot_programs: BusinessPilotProgramsRecord
	business_pilot_roster: BusinessPilotRosterRecord
	business_plans: BusinessPlansRecord
	business_post_comments: BusinessPostCommentsRecord
	business_posts: BusinessPostsRecord
	business_reconciliation_exceptions: BusinessReconciliationExceptionsRecord
	business_resources: BusinessResourcesRecord
	business_settlements: BusinessSettlementsRecord
	business_subscription_events: BusinessSubscriptionEventsRecord
	business_subscription_invoices: BusinessSubscriptionInvoicesRecord
	business_subscriptions: BusinessSubscriptionsRecord
	business_support_cases: BusinessSupportCasesRecord
	client_diagnostic_rate_buckets: ClientDiagnosticRateBucketsRecord
	client_diagnostics: ClientDiagnosticsRecord
	contact_discovery_requests: ContactDiscoveryRequestsRecord
	countries: CountriesRecord
	customer_receipts: CustomerReceiptsRecord
	ephemeral_rsvps: EphemeralRsvpsRecord
	event_age_profiles: EventAgeProfilesRecord
	event_anticipation_options: EventAnticipationOptionsRecord
	event_anticipation_prompts: EventAnticipationPromptsRecord
	event_anticipation_responses: EventAnticipationResponsesRecord
	event_anticipation_state: EventAnticipationStateRecord
	event_bookmarks: EventBookmarksRecord
	event_chats: EventChatsRecord
	event_chats_view: EventChatsViewRecord
	event_check_in_audit: EventCheckInAuditRecord
	event_company_blocks: EventCompanyBlocksRecord
	event_company_matches: EventCompanyMatchesRecord
	event_company_messages: EventCompanyMessagesRecord
	event_company_opt_ins: EventCompanyOptInsRecord
	event_company_rate_limits: EventCompanyRateLimitsRecord
	event_company_reactions: EventCompanyReactionsRecord
	event_company_reports: EventCompanyReportsRecord
	event_company_room_members: EventCompanyRoomMembersRecord
	event_company_room_signals: EventCompanyRoomSignalsRecord
	event_company_rooms: EventCompanyRoomsRecord
	event_content_reports: EventContentReportsRecord
	event_feedback: EventFeedbackRecord
	event_impressions: EventImpressionsRecord
	event_members: EventMembersRecord
	event_memories: EventMemoriesRecord
	event_notification_deliveries: EventNotificationDeliveriesRecord
	event_organizer_audit: EventOrganizerAuditRecord
	event_organizers: EventOrganizersRecord
	event_plan_options: EventPlanOptionsRecord
	event_plan_participants: EventPlanParticipantsRecord
	event_plan_votes: EventPlanVotesRecord
	event_plans: EventPlansRecord
	event_post_comments: EventPostCommentsRecord
	event_post_comments_view: EventPostCommentsViewRecord
	event_posts: EventPostsRecord
	event_posts_view: EventPostsViewRecord
	event_refund_requests: EventRefundRequestsRecord
	event_series: EventSeriesRecord
	event_ticket_challenges: EventTicketChallengesRecord
	event_ticket_transfers: EventTicketTransfersRecord
	event_tickets: EventTicketsRecord
	event_view: EventViewRecord
	events: EventsRecord
	events_view: EventsViewRecord
	feature_flags: FeatureFlagsRecord
	group_categories: GroupCategoriesRecord
	group_invite_links: GroupInviteLinksRecord
	group_members: GroupMembersRecord
	group_members_view: GroupMembersViewRecord
	group_post_comments: GroupPostCommentsRecord
	group_post_comments_view: GroupPostCommentsViewRecord
	group_posts: GroupPostsRecord
	group_posts_view: GroupPostsViewRecord
	group_view: GroupViewRecord
	groups: GroupsRecord
	groups_view: GroupsViewRecord
	host_event_analytics: HostEventAnalyticsRecord
	host_reliability_signals: HostReliabilitySignalsRecord
	launch_events: LaunchEventsRecord
	moderation_actions: ModerationActionsRecord
	moderation_appeals: ModerationAppealsRecord
	moderation_reports: ModerationReportsRecord
	notification_digest_deliveries: NotificationDigestDeliveriesRecord
	notifications: NotificationsRecord
	notifications_view: NotificationsViewRecord
	people_circle_members: PeopleCircleMembersRecord
	people_circles: PeopleCirclesRecord
	people_list_members: PeopleListMembersRecord
	people_lists: PeopleListsRecord
	phone_verification_attempts: PhoneVerificationAttemptsRecord
	plan_match_rate_limits: PlanMatchRateLimitsRecord
	platform_admin_actions: PlatformAdminActionsRecord
	platform_settings: PlatformSettingsRecord
	post_event_continuity_state: PostEventContinuityStateRecord
	privacy_action_audit: PrivacyActionAuditRecord
	profile_blocks: ProfileBlocksRecord
	push_subscriptions: PushSubscriptionsRecord
	recent_people: RecentPeopleRecord
	resource_availability_rules: ResourceAvailabilityRulesRecord
	resource_blackouts: ResourceBlackoutsRecord
	resource_booking_audit: ResourceBookingAuditRecord
	resource_bookings: ResourceBookingsRecord
	resource_maintenance: ResourceMaintenanceRecord
	resource_operation_notification_deliveries: ResourceOperationNotificationDeliveriesRecord
	resource_operations_audit: ResourceOperationsAuditRecord
	resource_staff_assignments: ResourceStaffAssignmentsRecord
	saved_feeds: SavedFeedsRecord
	saved_people: SavedPeopleRecord
	seed_run_resources: SeedRunResourcesRecord
	seed_runs: SeedRunsRecord
	timezones: TimezonesRecord
	travel_reminders: TravelRemindersRecord
	user_availability: UserAvailabilityRecord
	user_presence: UserPresenceRecord
	users: UsersRecord
	users_view: UsersViewRecord
	venue_applications: VenueApplicationsRecord
	venue_audit_log: VenueAuditLogRecord
	venue_event_insights: VenueEventInsightsRecord
	venue_staff: VenueStaffRecord
	vipps_financial_audit: VippsFinancialAuditRecord
	vipps_payment_attempts: VippsPaymentAttemptsRecord
}

export type CollectionResponses = {
	_authOrigins: AuthoriginsResponse
	_externalAuths: ExternalauthsResponse
	_mfas: MfasResponse
	_otps: OtpsResponse
	_superusers: SuperusersResponse
	admin_impersonation_sessions: AdminImpersonationSessionsResponse
	business_community_rate_limits: BusinessCommunityRateLimitsResponse
	business_community_safety: BusinessCommunitySafetyResponse
	business_conversations: BusinessConversationsResponse
	business_embed_configs: BusinessEmbedConfigsResponse
	business_embed_rate_limits: BusinessEmbedRateLimitsResponse
	business_embed_referral_daily: BusinessEmbedReferralDailyResponse
	business_entitlements: BusinessEntitlementsResponse
	business_feature_flags: BusinessFeatureFlagsResponse
	business_finance_access: BusinessFinanceAccessResponse
	business_finance_audit: BusinessFinanceAuditResponse
	business_finance_ledger: BusinessFinanceLedgerResponse
	business_follows: BusinessFollowsResponse
	business_messages: BusinessMessagesResponse
	business_pilot_audit: BusinessPilotAuditResponse
	business_pilot_programs: BusinessPilotProgramsResponse
	business_pilot_roster: BusinessPilotRosterResponse
	business_plans: BusinessPlansResponse
	business_post_comments: BusinessPostCommentsResponse
	business_posts: BusinessPostsResponse
	business_reconciliation_exceptions: BusinessReconciliationExceptionsResponse
	business_resources: BusinessResourcesResponse
	business_settlements: BusinessSettlementsResponse
	business_subscription_events: BusinessSubscriptionEventsResponse
	business_subscription_invoices: BusinessSubscriptionInvoicesResponse
	business_subscriptions: BusinessSubscriptionsResponse
	business_support_cases: BusinessSupportCasesResponse
	client_diagnostic_rate_buckets: ClientDiagnosticRateBucketsResponse
	client_diagnostics: ClientDiagnosticsResponse
	contact_discovery_requests: ContactDiscoveryRequestsResponse
	countries: CountriesResponse
	customer_receipts: CustomerReceiptsResponse
	ephemeral_rsvps: EphemeralRsvpsResponse
	event_age_profiles: EventAgeProfilesResponse
	event_anticipation_options: EventAnticipationOptionsResponse
	event_anticipation_prompts: EventAnticipationPromptsResponse
	event_anticipation_responses: EventAnticipationResponsesResponse
	event_anticipation_state: EventAnticipationStateResponse
	event_bookmarks: EventBookmarksResponse
	event_chats: EventChatsResponse
	event_chats_view: EventChatsViewResponse
	event_check_in_audit: EventCheckInAuditResponse
	event_company_blocks: EventCompanyBlocksResponse
	event_company_matches: EventCompanyMatchesResponse
	event_company_messages: EventCompanyMessagesResponse
	event_company_opt_ins: EventCompanyOptInsResponse
	event_company_rate_limits: EventCompanyRateLimitsResponse
	event_company_reactions: EventCompanyReactionsResponse
	event_company_reports: EventCompanyReportsResponse
	event_company_room_members: EventCompanyRoomMembersResponse
	event_company_room_signals: EventCompanyRoomSignalsResponse
	event_company_rooms: EventCompanyRoomsResponse
	event_content_reports: EventContentReportsResponse
	event_feedback: EventFeedbackResponse
	event_impressions: EventImpressionsResponse
	event_members: EventMembersResponse
	event_memories: EventMemoriesResponse
	event_notification_deliveries: EventNotificationDeliveriesResponse
	event_organizer_audit: EventOrganizerAuditResponse
	event_organizers: EventOrganizersResponse
	event_plan_options: EventPlanOptionsResponse
	event_plan_participants: EventPlanParticipantsResponse
	event_plan_votes: EventPlanVotesResponse
	event_plans: EventPlansResponse
	event_post_comments: EventPostCommentsResponse
	event_post_comments_view: EventPostCommentsViewResponse
	event_posts: EventPostsResponse
	event_posts_view: EventPostsViewResponse
	event_refund_requests: EventRefundRequestsResponse
	event_series: EventSeriesResponse
	event_ticket_challenges: EventTicketChallengesResponse
	event_ticket_transfers: EventTicketTransfersResponse
	event_tickets: EventTicketsResponse
	event_view: EventViewResponse
	events: EventsResponse
	events_view: EventsViewResponse
	feature_flags: FeatureFlagsResponse
	group_categories: GroupCategoriesResponse
	group_invite_links: GroupInviteLinksResponse
	group_members: GroupMembersResponse
	group_members_view: GroupMembersViewResponse
	group_post_comments: GroupPostCommentsResponse
	group_post_comments_view: GroupPostCommentsViewResponse
	group_posts: GroupPostsResponse
	group_posts_view: GroupPostsViewResponse
	group_view: GroupViewResponse
	groups: GroupsResponse
	groups_view: GroupsViewResponse
	host_event_analytics: HostEventAnalyticsResponse
	host_reliability_signals: HostReliabilitySignalsResponse
	launch_events: LaunchEventsResponse
	moderation_actions: ModerationActionsResponse
	moderation_appeals: ModerationAppealsResponse
	moderation_reports: ModerationReportsResponse
	notification_digest_deliveries: NotificationDigestDeliveriesResponse
	notifications: NotificationsResponse
	notifications_view: NotificationsViewResponse
	people_circle_members: PeopleCircleMembersResponse
	people_circles: PeopleCirclesResponse
	people_list_members: PeopleListMembersResponse
	people_lists: PeopleListsResponse
	phone_verification_attempts: PhoneVerificationAttemptsResponse
	plan_match_rate_limits: PlanMatchRateLimitsResponse
	platform_admin_actions: PlatformAdminActionsResponse
	platform_settings: PlatformSettingsResponse
	post_event_continuity_state: PostEventContinuityStateResponse
	privacy_action_audit: PrivacyActionAuditResponse
	profile_blocks: ProfileBlocksResponse
	push_subscriptions: PushSubscriptionsResponse
	recent_people: RecentPeopleResponse
	resource_availability_rules: ResourceAvailabilityRulesResponse
	resource_blackouts: ResourceBlackoutsResponse
	resource_booking_audit: ResourceBookingAuditResponse
	resource_bookings: ResourceBookingsResponse
	resource_maintenance: ResourceMaintenanceResponse
	resource_operation_notification_deliveries: ResourceOperationNotificationDeliveriesResponse
	resource_operations_audit: ResourceOperationsAuditResponse
	resource_staff_assignments: ResourceStaffAssignmentsResponse
	saved_feeds: SavedFeedsResponse
	saved_people: SavedPeopleResponse
	seed_run_resources: SeedRunResourcesResponse
	seed_runs: SeedRunsResponse
	timezones: TimezonesResponse
	travel_reminders: TravelRemindersResponse
	user_availability: UserAvailabilityResponse
	user_presence: UserPresenceResponse
	users: UsersResponse
	users_view: UsersViewResponse
	venue_applications: VenueApplicationsResponse
	venue_audit_log: VenueAuditLogResponse
	venue_event_insights: VenueEventInsightsResponse
	venue_staff: VenueStaffResponse
	vipps_financial_audit: VippsFinancialAuditResponse
	vipps_payment_attempts: VippsPaymentAttemptsResponse
}

// Utility types for create/update operations

type ProcessCreateAndUpdateFields<T> = Omit<{
	// Omit AutoDate fields
	[K in keyof T as Extract<T[K], IsoAutoDateString> extends never ? K : never]: 
		// Convert FileNameString to File
		T[K] extends infer U ? 
			U extends (FileNameString | FileNameString[]) ? 
				U extends any[] ? File[] : File 
			: U
		: never
}, 'id'>

// Create type for Auth collections
export type CreateAuth<T> = {
	id?: RecordIdString
	email: string
	emailVisibility?: boolean
	password: string
	passwordConfirm: string
	verified?: boolean
} & ProcessCreateAndUpdateFields<T>

// Create type for Base collections
export type CreateBase<T> = {
	id?: RecordIdString
} & ProcessCreateAndUpdateFields<T>

// Update type for Auth collections
export type UpdateAuth<T> = Partial<
	Omit<ProcessCreateAndUpdateFields<T>, keyof AuthSystemFields>
> & {
	email?: string
	emailVisibility?: boolean
	oldPassword?: string
	password?: string
	passwordConfirm?: string
	verified?: boolean
}

// Update type for Base collections
export type UpdateBase<T> = Partial<
	Omit<ProcessCreateAndUpdateFields<T>, keyof BaseSystemFields>
>

// Get the correct create type for any collection
export type Create<T extends keyof CollectionResponses> =
	CollectionResponses[T] extends AuthSystemFields
		? CreateAuth<CollectionRecords[T]>
		: CreateBase<CollectionRecords[T]>

// Get the correct update type for any collection
export type Update<T extends keyof CollectionResponses> =
	CollectionResponses[T] extends AuthSystemFields
		? UpdateAuth<CollectionRecords[T]>
		: UpdateBase<CollectionRecords[T]>

// Type for usage with type asserted PocketBase instance
// https://github.com/pocketbase/js-sdk#specify-typescript-definitions

export type TypedPocketBase = {
	collection<T extends keyof CollectionResponses>(
		idOrName: T
	): RecordService<CollectionResponses[T]>
} & PocketBase
